import { App, Button, Card, Col, Flex, Form, Input, List,  Modal, Progress, Row, Table, Tabs, Upload, UploadFile, UploadProps } from "antd";
import { useEffect, useRef, useState } from "react";
import { InvitedNewParticipant, InvitedParticipant, ProjectInfoInterface } from "../../model/IprojectInfo";
import moment from "moment";
import {
    UploadOutlined,
    DownloadOutlined,
    CheckOutlined,
    CloseOutlined
  } from '@ant-design/icons';
import useApp from "antd/es/app/useApp";
import { FacilityInterface, ResearcherInterface } from "../../model/IResearcher";
import axios from "axios";
import 'moment/locale/th';
import CkEditor from "../../ckeditor/ckEditor";
import { Editor } from "ckeditor5";
import { FlieListInterface } from "../../model/IFileList";
import LoadingOverlay from 'react-loading-overlay-ts';
import { useNavigate } from "react-router-dom";
import TextArea from "antd/es/input/TextArea";
import { RcFile } from "antd/es/upload";

moment.locale('th'); 


type Issue = {
    topic: string;
    consideration_issues: string;
  };
  
export function ProjectInfo(){
    const [form] = Form.useForm();
    const [editable,setEditable] = useState(true);
    const [AllData,setAlldata] = useState<ProjectInfoInterface>();
    const [HisAllData,setHisAllData] = useState<ProjectInfoInterface>();
    const [ParticipantAmount,setParticipantAmount] = useState('')
    const [ParticipantGroupBy,setParticipantGroupBy] = useState('')
    const [ParticipantProcedure,setParticipantProcedure] = useState('')
    const [Percentage,setPercentage]= useState(0);
    const [ApprovalFileData,setApprovalFileData] = useState<string | null>(null);

    const [Part11Status,setPart11Status]= useState(true);
    const [Part12Status,setPart12Status]= useState(true);
    const [Part13Status,setPart13Status]= useState(true);
    const [Part14Status,setPart14Status]= useState(true);
    const [Part15Status,setPart15Status]= useState(true);
    const [Part2Status,setPart2Status]= useState(true);
    const [Part3Status,setPart3Status]= useState(true);
    const [Part3OutlineStatus,setPart3OutlineStatus]= useState(true);
    const [Part3CourseStatus,setPart3CourseStatus]= useState(true);
    const [Part3RecieptStatus,setPart3RecieptStatus]= useState(true);

    const [HeadResData,setHeadResdata] = useState<ResearcherInterface>();
    const [HeadExResData,setHeadExResdata] = useState<ResearcherInterface>();
    const [researcher_position, setresearcher_position] = useState('');
    const [JoinedData,setJoinedData] = useState<ResearcherInterface[]>([]);
    const [JoinedExData,setJoinedExData] = useState<ResearcherInterface[]>([]);
    const [facData,setFacData] = useState<FacilityInterface>();
    const [AllFileList,setAllFileList] = useState<FlieListInterface[]>([])
    const [Topic,setTopic] = useState('')

    const ParticipantAmountRef = useRef<Editor | null>(null);
    const ParticipantProcedureRef = useRef<Editor | null>(null);
    const ParticipantGroupByRef = useRef<Editor | null>(null);

    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const [FileType,setFileType] = useState<string | null>(null);
    
    const [invitedParticipant, setInvitedParticipant] = useState<InvitedParticipant>({
        healthy: {
          count: null,
          note:'',
          age:'',
          age_year: null,
          age_month: null,
          gender: [],
        },
        patient: {
          count: null,
          note:'',
          age:'',
          age_year: null,
          age_month: null,
          gender: [],
        },
        other: {
        othertype:'',
        count: null,
          note:'',
          age:'',
          age_year: null,
          age_month: null,
          gender: [],
        },
      });
    const [NewinvitedParticipant, setNewInvitedParticipant] = useState<InvitedNewParticipant>({
    normal: {
        count: null,
        note:'',
        age:'',
        age_year: null,
        age_month: null,
        gender: [],
        },
    kids: {
    count: null,
    note:'',
    age:'',
    age_year: null,
    age_month: null,
    gender: [],
    },
    vulnerable: {
    count: null,
    note:'',
    age:'',
    age_year: null,
    age_month: null,
    gender: [],
    },
    });
      const [invitedParticipantHistory, setInvitedParticipantHistory] = useState<InvitedParticipant>({
        healthy: {
          count: null,
          note:'',
          age:'',
          age_year: null,
          age_month: null,
          gender: [],
        },
        patient: {
          count: null,
          note:'',
          age:'',
          age_year: null,
          age_month: null,
          gender: [],
        },
        other: {
        othertype:'',
        count: null,
          note:'',
          age:'',
          age_year: null,
          age_month: null,
          gender: [],
        },
      });
      const [NewinvitedParticipantHistory, setNewInvitedParticipantHistory] = useState<InvitedNewParticipant>({
    normal: {
        count: null,
        note:'',
        age:'',
        age_year: null,
        age_month: null,
        gender: [],
        },
    kids: {
    count: null,
    note:'',
    age:'',
    age_year: null,
    age_month: null,
    gender: [],
    },
    vulnerable: {
    count: null,
    note:'',
    age:'',
    age_year: null,
    age_month: null,
    gender: [],
    },
    });

        function arraysHaveSameMembers(a: string[], b: string[]) {
            if (a.length !== b.length) return false;
            return a.every(val => b.includes(val));
            }
      const [selectedTypes, setSelectedTypes] = useState<string[]>([]);
  
    const { message,notification } = App.useApp();
    const {ROCKEditors,CKEditors,getHTML} = CkEditor();
    const [FileAttachment, setFileAttachment] = useState([
        {   
            id:1,
            AttachmentType:'เค้าโครงวิจัย 3 บท',
            Status:'ยังไม่แนบ'
        },{
            id:2,
            AttachmentType:'เครื่องมือหรือแบบสอบถาม (ถ้ามี)',
            Status:'ยังไม่แนบ'
        },
        {
            id:3,
            AttachmentType:'หนังสือรับรองการประเมินคุณภาพเครื่องมือวิจัย(ถ้ามี)',
            Status:'ยังไม่แนบ'
        },
        {
            id:4,
            AttachmentType:'เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครทั่วไป (ถ้าเกี่ยวข้อง)',
            Status:'ยังไม่แนบ'
        },
        {
            id:5,
            AttachmentType:'เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครเด็ก 7-18 ปี (ถ้าเกี่ยวข้อง)',
            Status:'ยังไม่แนบ'
        },
        {
            id:6,
            AttachmentType:'เอกสารแสดงความยินยอมสำหรับอาสาสมัครกลุ่มเปราะบาง (ถ้าเกี่ยวข้อง)',
            Status:'ยังไม่แนบ'
        },
        {
            id:7,
            AttachmentType:'เอกสารรับรองการสอบผ่านโครงร่างวิทยานิพนธ์ ภาคนิพนธ์ หรือการศึกษาค้นคว้าอิสระ',
            Status:'ยังไม่แนบ'
        },
        {
            id:8,
            AttachmentType:'เอกสารสัญญาการให้ทุนวิจัย (ถ้ามี)',
            Status:'ยังไม่แนบ'
        },
        {
            id:9,
            AttachmentType:'หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์',
            Status:'ยังไม่แนบ'
        },
        {
            id:10,
            AttachmentType:'หลักฐานการชำระเงินค่าธรรมเนียมในการพิจารณาจริยธรรมการวิจัยในมนุษย์',
            Status:'ยังไม่แนบ'
        },
        {
            id:11,
            AttachmentType:'หลักฐานการรับรองคำพิจารณาจริยธรรมจากที่ปรึกษา (สำหรับนักศึกษา)',
            Status:'ยังไม่แนบ'
          },
    ]);

    const participants = [
        {
          order_id: 1,
          researcher_THname: sessionStorage.getItem('fullname') || 'error',
          join_per: HeadResData?.join_per || 0,
        },
        ...(JoinedData.length>0
            ? JoinedData.map((r, idx) => ({
                order_id: idx + 2, // head is order 1
                researcher_THname: r.researcher_THname,
                join_per: r.join_per || 0,
              }))
            : []),
      ];

    const navigate = useNavigate();

    async function getData(){
        console.log('check multiple run')
        await axios.get(`${process.env.REACT_APP_BASE}/getFullProjectInfo/${sessionStorage.getItem('Order_ID')}/${sessionStorage.getItem('user')}`).then(response=>{
            if(response.status=200)
                {
                    const tmpdata = response.data.data
                    setAlldata(tmpdata)

                    setParticipantAmount(tmpdata.ParticipantAmount)
                    setParticipantGroupBy(tmpdata.ParticipantGroupBy)
                    setParticipantProcedure(tmpdata.ParticipantProcedure)
                    
                    if(tmpdata.project_status=='แก้ไข'||
                        tmpdata.project_status=='แก้ไขข้อมูลตามผลพิจารณา'
                    ){
                        setEditable(false)
                    }
                    const FaciData = sessionStorage.getItem('POS_ID');

                    setresearcher_position(tmpdata.posname)
        
                    if (FaciData) {
                        const TmpFacData = JSON.parse(FaciData)
                        setFacData(TmpFacData[0]);
                    }
                    if(tmpdata.InvitedParticipant!=null&&tmpdata.InvitedParticipant!=''){
                        const data = JSON.parse(tmpdata.InvitedParticipant);
                        const invitedTypes: string[] = [];
                        if (data?.patient) invitedTypes.push('ผู้ป่วย');
                        if (data?.healthy) invitedTypes.push('ผู้มีสุขภาพดี');
                        if (data?.other) invitedTypes.push('อื่น ๆ');

                        setSelectedTypes(invitedTypes)
                        setInvitedParticipant(data)
                        setNewInvitedParticipant(data)
                        
                    }
                    const head = response.data.Head
                    console.log(head)

                    setHeadResdata({
                        ...head,
                        join_per:head.joinper
                    })

                    const Joined = response.data.Joined
                    setJoinedData(
                        Joined.map((item: { joinper: any; }) => ({
                          ...item,
                          join_per: item.joinper,
                        }))
                      )

                    //check part1.1
                    
                        let progress = 0;
                      
                        // Check part 1.1
                        if (
                          tmpdata.project_nameTH &&
                          tmpdata.project_nameEN &&
                          tmpdata.posname &&
                          head 
                          && tmpdata.project_type 
                          && tmpdata.IsQuestionair
                          && (tmpdata.ResearchPeriod_year || tmpdata.ResearchPeriod_month )
                          && tmpdata.ResearchStartingDate && tmpdata.ResearchEndingDate 
                          && (tmpdata.InfoGatheringPeriod_month || tmpdata.InfoGatheringPeriod_year )
                          && tmpdata.InfoGatheringStartingDate 
                        && tmpdata.InfoGatheringEndingDate && (tmpdata.Projectfund||tmpdata.Projectfund==0)
                        ) {
                          console.log('part1.1')
                          progress += 6.8;
                          setPart11Status(false);
                        }
                        
                        // Check part 1.2
                        if (
                          tmpdata.IsbloodDraw &&
                          tmpdata.IsInvasiveProcedure &&
                          tmpdata.RiskAndUncomfortableFactor &&
                          tmpdata.DefensiveMeasure &&
                          tmpdata.ExpenseCoverage &&
                          tmpdata.AcceptanceUnderstanding &&
                          tmpdata.IsCountryReligionRiskFactor
                        ) {
                          console.log('part1.2')
                          progress += 6.8;
                          setPart12Status(false);
                        }
                        console.log(tmpdata.MedicineInfo)
                        // Check part 1.3
                        if (tmpdata.IsMedicine && tmpdata.applicableFactor) {
                          console.log('part1.3')
                          progress += 6.8;
                          setPart13Status(false)
                        }
                      
                        // Check part 1.4 
                        if (
                          tmpdata.IsCommercialInterlectualProperty &&
                          tmpdata.ProgressReport &&
                          tmpdata.PlagiarismPer
                        ) {
                          console.log('part1.4')
                          progress += 6.8;
                          setPart14Status(false)

                        }
                      
                        // Check part 1.5
                        if (tmpdata.LangRecieve && tmpdata.Acceptance) {
                          console.log('part1.5')
                          progress += 6.8;
                          setPart15Status(false)
                        }
                      
                        // Check part 2
                        if (
                          tmpdata.relevantTopic &&
                          tmpdata.Objective &&
                          tmpdata.ParticipantCharacteristicAndCriterion &&
                          tmpdata.ParticipantAmount &&
                          tmpdata.ParticipantRecruit &&
                          tmpdata.ParticipantReason &&
                          tmpdata.ParticipantProcedure &&
                          tmpdata.ParticipantAcknowledgementMethod &&
                          tmpdata.MedicalRecordInfoAllowedByHead &&
                          tmpdata.MedicalRecordactionAllowedByHead &&
                          tmpdata.RiskAndPrevent &&
                          tmpdata.Benefit &&
                          tmpdata.Coverage
                        ) {
                          console.log('part2')
                          progress += 33;
                          setPart2Status(false)
                        }
                      
                        setPercentage(progress);

                        if(tmpdata?.project_status!='แก้ไข'
                            &&tmpdata?.project_status!='รอตรวจสอบจากเจ้าหน้าที่'
                            &&tmpdata?.project_status!='รอตรวจสอบจากประธานจริยธรรม'
                            &&tmpdata?.project_status!='รอการพิจารณาจากกรรมการ'
                            &&tmpdata?.project_status!='รอการตรวจสอบผลพิจารณา'
                            &&tmpdata?.project_status!='รอการรับรองจากอธิการบดี'
                            &&tmpdata?.project_status!='ได้รับหนังสือรับรองจากอธิการบดี'
                            &&tmpdata?.project_status!='ได้รับหนังสือรับรองจากอธิการบดี'){
                            axios.get(`${process.env.REACT_APP_BASE}/getFullProjectInfoPasted/${sessionStorage.getItem('Order_ID')}/${sessionStorage.getItem('user')}`).then(res=>{
                                if(res.status==200){
                                    const tmphistData = res.data.data
                                    console.log(tmphistData)
                                    setHisAllData(tmphistData)
                                    if(tmphistData.InvitedParticipant){
                                        if(tmphistData.InvitedParticipant!=null&&tmphistData.InvitedParticipant!=''){
                                            const Histdata = JSON.parse(tmphistData.InvitedParticipant);
                                            const invitedTypes: string[] = [];
                                            if (Histdata?.patient) invitedTypes.push('ผู้ป่วย');
                                            if (Histdata?.healthy) invitedTypes.push('ผู้มีสุขภาพดี');
                                            if (Histdata?.other) invitedTypes.push('อื่น ๆ');
                    
                                            setSelectedTypes(invitedTypes)
                                            setNewInvitedParticipantHistory(Histdata)
                                        }
                                    }
                                    
                                    if(res.data.Head){
                                        const exhead = res.data.Head
                                        setHeadExResdata({
                                            ...exhead,
                                            join_per:exhead.joinper
                                        })
                                    }
                                  
                                    const ExJoined = res.data.Joined
                                        setJoinedExData(
                                            ExJoined.map((item: { joinper: any; }) => ({
                                            ...item,
                                            join_per: item.joinper,
                                            }))
                                        )
                                    
                                }
                            })
                        }else{
                            console.log('test')
                        }
                      
                }

        })
       
        await axios
        .get(`${process.env.REACT_APP_BASE}/getFileList/${sessionStorage.getItem('Order_ID')}`)
        .then((res) => {
          if (res.status === 200 && res.data) {
            const uploadedFiles = res.data; // Array of { Topic: string }
      
            const updatedList = FileAttachment.map((item) => {
              const isUploaded = uploadedFiles.some(
                (file: { Topic: string }) => file.Topic === item.AttachmentType
              );
              return {
                ...item,
                Status: isUploaded ? 'แนบแล้ว' : 'ยังไม่แนบ',
              };
            });
      
            setAllFileList(uploadedFiles);
            setFileAttachment(updatedList);
      
            const requiredTopics = [
              'เค้าโครงวิจัย 3 บท',
              'หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์',
              'หลักฐานการชำระเงินค่าธรรมเนียมในการพิจารณาจริยธรรมการวิจัยในมนุษย์',
            ];
      
            const allRequiredUploaded = requiredTopics.every((requiredTopic) =>
              uploadedFiles.some((file: { Topic: string }) => file.Topic.trim() === requiredTopic)
            );

            if(uploadedFiles.filter
                ((item:{ Topic: string })=>item.Topic.trim()=='เค้าโครงวิจัย 3 บท').length!=0){
                setPart3OutlineStatus(false)
            }
            if(uploadedFiles.filter((item:{ Topic: string })=>item.Topic.trim()=='หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์').length!=0){
                setPart3CourseStatus(false)
            }
            if(uploadedFiles.filter((item:{ Topic: string })=>item.Topic.trim()=='หลักฐานการชำระเงินค่าธรรมเนียมในการพิจารณาจริยธรรมการวิจัยในมนุษย์').length!=0){
                setPart3RecieptStatus(false)
            }
      
            if (allRequiredUploaded) {
                console.log('part3')
                setPart3Status(false)
                setPercentage((prev) => prev + 33); // Only add if all 3 found
            }
          }
        });
      }


    useEffect(() => {
        if(!sessionStorage.getItem('Order_ID')){
            navigate(`/VU_HREC`)
        }else{
            getData();
        }
    }, []);

    const fetchApprovalFile = async (orderId: string) => {
        console.log('fetch file from '+ orderId)
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BASE}/ApprovalGet/${orderId}`
          );
      
          if (res.status === 200 && res.data) {
            const { fileData, fileType, fileName } = res.data;

            const fileUrl = `data:${fileType};base64,${fileData}`;
            console.log(fileUrl)
            setApprovalFileData(fileUrl);

          }
        } catch (err: any) {
          if (axios.isAxiosError(err) && err.response?.status === 404) {
            // No file yet -> do nothing
            setApprovalFileData(null); 
          } else {
            console.error("Error fetching approval file:", err);
            message.error("เกิดข้อผิดพลาดในการดึงไฟล์");
          }
        }
      };

    useEffect(() => {
        if (!AllData) return;
        console.log('project status is '+AllData?.project_status)
        
        if (AllData?.project_status === 'ได้รับหนังสือรับรองจากอธิการบดี') {
          fetchApprovalFile(sessionStorage.getItem('Order_ID') || '');
        }
      }, [AllData]);
      
    const [ShowFile,setShowFile] = useState(false);
    const [ShowMultipleFiles,setShowMultipleFiles] = useState(false);
    const [ShowImage,setShowImage] = useState(false);
    const [SubFileList,setSubFileList] = useState<FlieListInterface[]>([])
    const [submit,setSubmit] = useState(false);
    const [isActive,setisActive]= useState(false);

    async function viewFile(Topic:any){
        setTopic(Topic)
        if (Topic === "เครื่องมือหรือแบบสอบถาม (ถ้ามี)"
        ||Topic === "เอกสารสัญญาการให้ทุนวิจัย (ถ้ามี)"
          ) {
              setisActive(true);
              const filtered = AllFileList.filter(item => item.Topic.trim() === Topic);
              console.log(filtered);
              setSubFileList(filtered);
              setShowMultipleFiles(true);
              setisActive(false);
          }else if(Topic=='หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์'){
          
          const filtered = AllFileList.filter(item => item.Topic.trim() === Topic);
          console.log(filtered[0].FileType)
          if(filtered[0].FileType=='image/jpeg'||filtered[0].FileType=='image/png'){
              setPreviewUrl(`${process.env.REACT_APP_BASE}/getImage/${filtered[0].FileID}`)
              setShowImage(true);
          }else{
              const data = {
                  topic:Topic
              }
  
              await axios.post(
                  `${process.env.REACT_APP_BASE}/GetFile/${sessionStorage.getItem('Order_ID')}`,
                  data,
                  { responseType: 'blob' }
                  ).then(response => {
                  if (response.status === 200) {
                      
                      const blob = response.data; // Axios already gives you a Blob
                      const blobUrl = URL.createObjectURL(blob);
                  
                      setPreviewUrl(blobUrl);    
                      setShowFile(true);       
                      setisActive(false);       
                  }
                  }).catch(err => {
                  console.error("Error while fetching file:", err);
                  setisActive(false);
                  });
          }
          }else{
              setisActive(true)
              const data = {
                  topic:Topic
              }
              
              await axios.post(
                  `${process.env.REACT_APP_BASE}/GetFile/${sessionStorage.getItem('Order_ID')}`,
                  data,
                  { responseType: 'blob' }
              ).then(response => {
                  if (response.status === 200) {
                      
                  const blob = response.data; // Axios already gives you a Blob
                  const blobUrl = URL.createObjectURL(blob);
              
                  setPreviewUrl(blobUrl);    
                  setShowFile(true);         
                  setisActive(false);       
                  }
              }).catch(err => {
                  console.error("Error while fetching file:", err);
                  setisActive(false);
              });
              
          }
    }

    async function ViewTool(id:any){
        const data = {
            topic:Topic,
        }
        await axios.post(
            `${process.env.REACT_APP_BASE}/GetFileForMultiplePDFAccept/${sessionStorage.getItem('Order_ID')}/${id}`,
            data,
            { responseType: 'blob' }
          ).then(response =>{
            if (response.status === 200) {
                setFileType(response.headers['content-type'])
                console.log('Content-Type:', response.headers['content-type']);

                const blob = response.data; 
                const blobUrl = URL.createObjectURL(blob);

                setPreviewUrl(blobUrl); 
            }
          }).catch(err => {
            console.error("Error while fetching file:", err);
            setisActive(false);
          });
      
    
        }
       
    function DeleteTool(id: any) {
        axios
          .delete(`${process.env.REACT_APP_BASE}/DeleteTool/${id}`)
          .then((response) => {
            if (response.status === 200) {
              axios
                .get(`${process.env.REACT_APP_BASE}/getFileList/${sessionStorage.getItem('Order_ID')}`)
                .then((res) => {
                  if (res.status === 200 && Array.isArray(res.data)) {
                    const uploadedFiles = res.data;
      
                    // Update status in FileAttachment
                    const updatedList = FileAttachment.map((item) => {
                      const isUploaded = uploadedFiles.some((file: { Topic: string }) =>
                        file.Topic?.trim() === item.AttachmentType?.trim()
                      );
                      return {
                        ...item,
                        Status: isUploaded ? 'แนบแล้ว' : 'ยังไม่แนบ',
                      };
                    });
      
                    setAllFileList(uploadedFiles);
                    setFileAttachment(updatedList);
      
                    setShowMultipleFiles(false);
                    setPreviewUrl(null);
                  }else if(res.status === 200){
                    setShowMultipleFiles(false);
                    setPreviewUrl(null);
                  }
                })
                .catch((err) => {
                  console.error('Error fetching file list after deletion:', err);
                });
            }
          })
          .catch((err) => {
            console.error('Error deleting file:', err);
          });
      }

    async function SubmitData(){
        if(AllData?.project_status == `แก้ไข`)
        {const Data = {
            id:sessionStorage.getItem('Order_ID'),
            user:sessionStorage.getItem('user'),
            status:sessionStorage.getItem('status')
        }
        await axios.post(`${process.env.REACT_APP_BASE}/SetSubmit`,Data).then(response=>{
            if(response.status==200){
                navigate('/VU_HREC')
            }else{
                notification.error({
                    message: 'ยี่นผลไม่สำเร็จ',
                    description: 'กรุณาตรวจสอบข้อมูลของท่าน',
                  });
            }
        })}else if(AllData?.project_status == `แก้ไขข้อมูลตามผลพิจารณา`){
            const FormData = form.getFieldsValue(); // <-- add ()
            const SentData = {
            id: sessionStorage.getItem('Order_ID'),
            user: sessionStorage.getItem('user'),
            status: sessionStorage.getItem('status'),
            researcher_issues_arguement: JSON.stringify(FormData?.researcher_issues_arguement )|| '',
            researcher_arguement: FormData?.researcher_arguement || '',
            };
            await axios.post(`${process.env.REACT_APP_BASE}/SetEdit`,SentData).then(response=>{
                if(response.status==200){
                    navigate('/VU_HREC')
                }else{
                    notification.error({
                        message: 'ยี่นผลไม่สำเร็จ',
                        description: 'กรุณาตรวจสอบข้อมูลของท่าน',
                      });
                }
            })}else{
            notification.error({
                message: 'ยี่นผลไม่สำเร็จ',
                description: 'พบข้อผิดพลาดในการยื่น',
              });
        }
    }

    const props: UploadProps = {
        name: 'file',
        action:  `${process.env.REACT_APP_BASE}/upload_pdf/${sessionStorage.getItem('Order_ID')}`,
        headers: {
          authorization: 'authorization-text',
        },
        async onChange(info) {
          if (info.file.status === 'done') {
            await axios
            .get(`${process.env.REACT_APP_BASE}/getFileList/${sessionStorage.getItem('Order_ID')}`)
            .then((res) => {
            if (res.status === 200 && res.data) {
                const uploadedFiles = res.data; // Array of { Topic: string }
        
                const updatedList = FileAttachment.map((item) => {
                const isUploaded = uploadedFiles.some(
                    (file: { Topic: string }) => file.Topic === item.AttachmentType
                );
                return {
                    ...item,
                    Status: isUploaded ? 'แนบแล้ว' : 'ยังไม่แนบ',
                };
                });
        
                setAllFileList(uploadedFiles);
                setFileAttachment(updatedList);
        
                const requiredTopics = [
                'เค้าโครงวิจัย 3 บท',
                'หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์',
                'หลักฐานการชำระเงินค่าธรรมเนียมในการพิจารณาจริยธรรมการวิจัยในมนุษย์',
                ];
        
                const allRequiredUploaded = requiredTopics.every((requiredTopic) =>
                uploadedFiles.some((file: { Topic: string }) => file.Topic.trim() === requiredTopic)
                );

                if(uploadedFiles.filter
                    ((item:{ Topic: string })=>item.Topic.trim()=='เค้าโครงวิจัย 3 บท').length!=0){
                    setPart3OutlineStatus(false)
                }
                if(uploadedFiles.filter((item:{ Topic: string })=>item.Topic.trim()=='หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์').length!=0){
                    setPart3CourseStatus(false)
                }
                if(uploadedFiles.filter((item:{ Topic: string })=>item.Topic.trim()=='เค้าโครงวิจัย 3 บท').length!=0){
                    setPart3RecieptStatus(false)
                }
        
                if (allRequiredUploaded) {
                    console.log('part3')
                    setPart3Status(false)
                    setPercentage((prev) => prev + 33); // Only add if all 3 found
                }
            }
            });
          } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
          }
        },
        
      };

    


    
    return (<>
    <LoadingOverlay
      active={isActive}
      spinner
      text='กำลังโหลดข้อมูล'
    >
    <h1>ข้อมูลโครงการที่ยื่นเข้าสู่ระบบ</h1>
    <hr/>
    {AllData?.project_status=='แก้ไข'&&<Row>
        <Col span={5}>
            <Progress type="circle" percent={Percentage} />
        </Col>
        <Col span={200} style={{ alignContent: 'center' }}>
            {Percentage<100 && <p>ขณะนี้โครงการของท่านมีการกรอกข้อมูลไปแล้ว {Percentage} เปอร์เซ็นต์จากทั้งหมด</p> || <p>ขณะนี้โครงการของท่านมีการกรอกข้อมูลครบถ้วนแล้วจากทั้งหมด</p>}
            <br/>
            <Progress percent={Percentage} style={{width:'60vh'}}/> 
        </Col>
    </Row>}
    {
        AllData?.project_status=='แก้ไขข้อมูลตามผลพิจารณา'||
        AllData?.project_status=='รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'&&
        <>
            <Card>
                <p style={{fontWeight:'bold'}}>โครงการของท่านมีการสั่งแก้ไขดังนี้</p>

                <h3><u>เกณฑ์โครงการวิจัย</u></h3>
                {AllData?.passed_measure&&<>{(AllData.review_type=='การพิจารณาแบบยกเว้น (Exemption)'&&
                    AllData?.passed_measure
                )
                &&<>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1. เป็นกิจกรรมการเรียนการสอน การประกันคุณภาพการศึกษา การประกันคุณภาพ โรงพยาบาล การปรับปรุงคุณภาพงาน การประเมินผลการให้บริการของหน่วยงาน ทั้งนี้ต้องเป็นการดำเนินการตามแนวทางที่กำหนด") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>} 1. เป็นกิจกรรมการเรียนการสอน การประกันคุณภาพการศึกษา การประกันคุณภาพ โรงพยาบาล การปรับปรุงคุณภาพงาน การประเมินผลการให้บริการของหน่วยงาน ทั้งนี้ต้องเป็นการดำเนินการตามแนวทางที่กำหนด</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("2. เป็นการวิจัยโดยใช้วิธีการสำรวจ สัมภาษณ์ ในประชากรที่เป็นผู้ใหญ่สุขภาพดี ทั้งนี้ต้อง") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2. เป็นการวิจัยโดยใช้วิธีการสำรวจ สัมภาษณ์ ในประชากรที่เป็นผู้ใหญ่สุขภาพดี ทั้งนี้ต้อง</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("2.1 ไม่มีหัวข้อ คำถามที่อ่อนไหว เช่น พฤติกรรมทางเพศ พฤติกรรมผิดกฎหมาย พฤติกรรมที่เสื่อมเสียชื่อเสียงต่อบุคคล/ชุมชน") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2.1 ไม่มีหัวข้อ คำถามที่อ่อนไหว เช่น พฤติกรรมทางเพศ พฤติกรรมผิดกฎหมาย พฤติกรรมที่เสื่อมเสียชื่อเสียงต่อบุคคล/ชุมชน</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("2.2 ไม่ถามทัศนคติที่หากเปิดเผยจะเป็นผลเสียแก่การจ้างงาน เช่น การสำรวจความพึง พอใจของข้าราชการเกี่ยวกับสวัสดิการที่ได้รับ") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2.2 ไม่ถามทัศนคติที่หากเปิดเผยจะเป็นผลเสียแก่การจ้างงาน เช่น การสำรวจความพึง พอใจของข้าราชการเกี่ยวกับสวัสดิการที่ได้รับ</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("2.3 ผลการสำรวจไม่ทำให้องค์กรที่ให้ข้อมูลเสื่อมเสียชื่อเสียง") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2.3 ผลการสำรวจไม่ทำให้องค์กรที่ให้ข้อมูลเสื่อมเสียชื่อเสียง</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("3. เป็นการวิจัยโดยการสังเกตพฤติกรรมของประชาชนในที่สาธารณะโดยที่") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3. เป็นการวิจัยโดยการสังเกตพฤติกรรมของประชาชนในที่สาธารณะโดยที่</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("3.1 ผู้วิจัยไม่ไปแทรกแซงหรือจัดฉาก") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3.1 ผู้วิจัยไม่ไปแทรกแซงหรือจัดฉาก </p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("}3.2 พฤติกรรมที่ถูกสังเกต/สถานที่ที่ใช้สังเกตไม่ล่วงล้ำความเป็นส่วนตัว") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3.2 พฤติกรรมที่ถูกสังเกต/สถานที่ที่ใช้สังเกตไม่ล่วงล้ำความเป็นส่วนตัว</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("3.3 ไม่บันทึกข้อมูลในลักษณะที่บ่งบอกถึงตัวบุคคลได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3.3 ไม่บันทึกข้อมูลในลักษณะที่บ่งบอกถึงตัวบุคคลได้</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("4. เป็นรายงานผู้ป่วย (Case Report) ที่ผู้เสนอขอยกเว้นได้แสดงการปกป้องความลับของผู้ป่วยอย่าง เหมาะสม (หมายเหตุ ผู้วิจัยพึงตระหนักว่าวารสารวิชาการหลายแห่งอาจกำหนดให้มีหลักฐานหนังสือความยินยอมขอใช้ข้อมูลผู้ป่วย หรือภาพผู้ป่วย แล้วแต่กรณี)") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}4. เป็นรายงานผู้ป่วย (Case Report) ที่ผู้เสนอขอยกเว้นได้แสดงการปกป้องความลับของผู้ป่วยอย่าง เหมาะสม (หมายเหตุ ผู้วิจัยพึงตระหนักว่าวารสารวิชาการหลายแห่งอาจกำหนดให้มีหลักฐานหนังสือความยินยอมขอใช้ข้อมูลผู้ป่วย หรือภาพผู้ป่วย แล้วแต่กรณี)  </p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("5. เป็นการวิจัยโดยทดสอบรสชาติอาหาร คุณภาพของอาหาร และความพึงพอใจของผู้บริโภคใน ภาพรวม โดยอาหารที่นำมาทดสอบต้องปลอดภัย และได้มาตรฐานตามข้อกำหนดของสำนักงานคณะกรรมการ อาหารและยา (อย.) ทั้งนี้ ขึ้นอยู่กับดุลยพินิจของประธานฯ หรือผู้ที่ได้รับมอบหมาย") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}5. เป็นการวิจัยโดยทดสอบรสชาติอาหาร คุณภาพของอาหาร และความพึงพอใจของผู้บริโภคใน ภาพรวม โดยอาหารที่นำมาทดสอบต้องปลอดภัย และได้มาตรฐานตามข้อกำหนดของสำนักงานคณะกรรมการ อาหารและยา (อย.) ทั้งนี้ ขึ้นอยู่กับดุลยพินิจของประธานฯ หรือผู้ที่ได้รับมอบหมาย  </p>
                </>}
                {(AllData.review_type=='การพิจารณาแบบเร่งรัด (Expedited Review)'&&
                AllData?.passed_measure)&&<>
                    <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1. ส่วนแก้ไขเพิ่มเติมโครงการวิจัยที่เป็นการแก้ไขเพิ่มเติมเล็กน้อยของโครงการวิจัยที่อนุมัติไปแล้วที่เป็นผลให้ความเสี่ยงของผู้ร่วมการวิจัยเพิ่มไม่เกินความเสี่ยงต่ำหรือไม่ทำให้การประเมินความเสี่ยงต่อผลประโยชน์เปลี่ยนไปอย่างมีนัยสำคัญ (Non-significant Risk) เช่น การแก้ไขคำผิด การแก้ไขรูปแบบการเขียนที่ ยังคงความหมายเดิม หรือการเปลี่ยนผู้วิจัยหรือที่อยู่ที่ติดต่อ </p>
                    <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2. โครงการวิจัยที่มีการสัมภาษณ์ ใช้แบบสอบถามและไม่เป็นข้อมูลลับ หรือข้อมูลที่อ่อนไหว และไม่ก่อผลเสียหายต่อสถานภาพ หรือสิทธิประโยชน์ของบุคคล และไม่ก้าวล่วงความอ่อนไหวของประชากรที่เกี่ยวข้อง</p>
                    <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3. การเก็บรวบรวมข้อมูล โดยมีวัตถุประสงค์เพื่อการวิจัยโดยกระบวนการที่ไม่รุกล้ำความเป็นส่วนตัวของบุคคลหรือกลุ่มบุคคล</p>
                    <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}4. การวิจัยเกี่ยวกับการใช้ข้อมูล (Data) บันทึก (Records) เอกสาร (Documents) ที่เก็บรวบรวมไว้แล้วโดยไม่เชื่อมโยงไปถึงตัวบุคคล</p>
                    <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}5. การวิจัยเกี่ยวกับพฤติกรรมที่เกี่ยวข้องกับลักษณะบุคคล กลุ่มบุคคล หรือการวิจัยที่ใช้วิธีการ สำรวจ สัมภาษณ์ ซักประวัติ การสนทนากลุ่ม (Focus Group) การประเมินโปรแกรมหรือวิธีการเกี่ยวกับการ ประกันคุณภาพ (Quality Assurance)  </p>
                </>}
                {(AllData.review_type=='การพิจารณาแบบเต็มชุด (Full Board Review)'&&
                AllData?.passed_measure)&&<>
                    <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.การวิจัยที่เกี่ยวข้องกับประชากรกลุ่มเปราะบาง (Vulnerable Group) ได้แก่") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.การวิจัยที่เกี่ยวข้องกับประชากรกลุ่มเปราะบาง (Vulnerable Group) ได้แก่</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.2 การวิจัยในผู้ป่วยที่ไม่สามารถรักษาหายได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.2 การวิจัยในผู้ป่วยที่ไม่สามารถรักษาหายได้</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.3 การวิจัยในผู้ป่วยด้วยโรคที่สังคมไม่ยอมรับ เช่น โรคเอดส์ เป็นต้น") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.3 การวิจัยในผู้ป่วยด้วยโรคที่สังคมไม่ยอมรับ เช่น โรคเอดส์ เป็นต้น</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.4 การวิจัยในผู้ที่มีความบกพร่องในการตัดสินใจ เช่น ผู้ที่มีความบกพร่องทางจิต ความทรงจำ หรือความผิดปกติด้านพฤติกรรม") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.4 การวิจัยในผู้ที่มีความบกพร่องในการตัดสินใจ เช่น ผู้ที่มีความบกพร่องทางจิต ความทรงจำ หรือความผิดปกติด้านพฤติกรรม</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.5 การวิจัยในเด็กที่อยู่ในสถานพินิจ/สถานสงเคราะห์") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.5 การวิจัยในเด็กที่อยู่ในสถานพินิจ/สถานสงเคราะห์</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.6 การวิจัยในกลุ่มผู้สูงอายุที่อยู่ในสถานสงเคราะห์</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.7 การวิจัยในทารกในครรภ์/หญิงตั้งครรภ์</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.8 การวิจัยในกลุ่มผู้ลี้ภัย</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.9 การวิจัยในนักโทษหรือผู้ต้องขัง</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.10 การวิจัยในกลุ่มคนไร้ที่อยู่</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.11 การวิจัยในชนกลุ่มน้อย หรือผู้ที่ไม่สามารถสื่อสารด้วยภาษาไทยได้</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.12 การวิจัยในกลุ่มผู้ขายบริการทางเพศ</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.13 การวิจัยในผู้เสพหรือผู้ขายสารเสพติด</p>
                    <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2. การเปิดเผยตัวของผู้ร่วมการวิจัยก่อให้เกิดความเสี่ยงต่อการรับโทษทางแพ่ง หรือทางอาญา หรือเป็นผลเสียต่อสถานะทางการเงิน การจ้างงาน การประกัน หรืออาชีพ หรือถูกตีตรา เว้นแต่ โครงการวิจัยได้แสดงมาตรการปกป้องการรุกล้ำความเป็นส่วนตัว และความลับไม่ให้รั่วไหลอย่างเหมาะสมจนความเสี่ยงเหลือไม่เกินความเสี่ยงต่ำ</p>
                    <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3. โครงการวิจัยที่ได้รับการพิจารณาให้การรับรองแล้ว และผู้วิจัยต้องการยื่นส่วนแก้ไขเปลี่ยนแปลง (Amendment) ซึ่งส่วนแก้ไขเพิ่มเติมนั้นมีผลกระทบเปลี่ยนแปลงความเสี่ยงของผู้ร่วมการวิจัยที่เพิ่มขึ้นมากกว่าเกณฑ์การประเมินโครงการวิจัยแบบเร่งรัด ต้องนำเข้าพิจารณาแบบเต็มชุด </p>
                    <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>} 4. โครงการวิจัยที่ได้รับการรับรองแล้วและผู้วิจัยต้องการรายงานความก้าวหน้าของโครงการ (Progress Report) แต่มีการดำเนินการที่เบี่ยงเบนไม่ปฏิบัติตามหรือฝ่าฝืนโครงการวิจัยต้องนำเข้า พิจารณาแบบเต็มชุด</p>
                </>}</>}

                <br/>
               {AllData?.consideration_issues&&<> 
                <h3><u>ประเด็นพิจารณา</u></h3>
                    <Table columns={[
                        {
                            title:'ประเด็นพิจารณา',
                            dataIndex:'topic',
                            width:'15vw'
                        },{
                            title: 'ข้อเสนอแนะ',
                            dataIndex: 'consideration_issues',
                            render: (text: string) => (
                              <p
                                style={{ fontSize: '16px', marginLeft: 20 }}
                                dangerouslySetInnerHTML={{
                                  __html: (text || '').replace(/\r\n|\n|\r/g, '<br/>'),
                                }}
                              />
                            ),
                          }
                    ]} 
                    pagination={false} 
                    dataSource={JSON.parse(AllData.consideration_issues) as Issue[]}/></>}
                {AllData?.suggestion&&<>
                <br/>
                <p><span style={{fontWeight:'bold'}}>ข้อเสนอแนะเพิ่มเติม</span> : {AllData?.suggestion}</p>
                <Card>
                    <p color='red'>ขอความอนุเคราะห์โปรดทำไฮท์ไลท์ในไฟล์ที่ท่านแก้ไขด้วย</p>
                </Card>
                </>}
            </Card>
        </>
    }
    {/* {
        Percentage<100&&
        <>  
        <br/>
            <Card>
                <h3>ระบบได้ตรวจพบว่าท่านยังกรอกข้อมูลไม่ครบถ้วน กรุณาเพิ่มข้อมูลดังต่อไปนี้ก่อนยื่นโครงการ</h3>
                <Card>
                    {
                        (Part11Status
                          ||Part12Status
                          ||Part13Status
                          ||Part14Status
                          ||Part15Status
                        )&&<>
                            <p style={{fontWeight:'bold',color:'red'}}>มว.จ.001 คำขอรับรองการพิจารณาจริยธรรมการวิจัยในมนุษย์</p>
                            {Part11Status&&<p style={{marginLeft:20,color:'red'}}>1. ข้อมูลเบื้องต้น</p>}
                            {Part12Status&&<p style={{marginLeft:20,color:'red'}}>2. การพิจารณาจริยธรรม</p>}
                            {Part13Status&&<p style={{marginLeft:20,color:'red'}}>3. ยา</p>}
                            {Part14Status&&<p style={{marginLeft:20,color:'red'}}>4. ทรัพย์สินทางปัญญาและอื่น</p>}
                            {Part15Status&&<p style={{marginLeft:20,color:'red'}}>5. คำรับรองจากผู้วิจัย</p>}

                        </>
                    }
                    {
                        (Part2Status)&&
                        <>
                            <p style={{fontWeight:'bold',color:'red'}}>มว.จ.002 แบบเอกสารชี้แจงอาสาสมัครเพื่อประกอบการพิจารณาจริยธรรมการวิจัยในมนุษย์</p>
                        </>
                    }
                    {(Part2Status&&Part3Status)&&<>
                    <hr/>
                    </>}
                    {
                        (Part3Status)&&
                        <>
                            <p style={{fontWeight:'bold',color:'red'}}>เอกสารเพิ่มเติม</p>
                            {Part3OutlineStatus&&
                                <p style={{fontWeight:'bold',color:'red'}}>- เค้าโครงวิจัย 3 บท</p>
                            }
                            {Part3CourseStatus&&
                                <p style={{fontWeight:'bold',color:'red'}}>- หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์</p>
                            }
                            {Part3RecieptStatus&&
                                <p style={{fontWeight:'bold',color:'red'}}>- หลักฐานการชำระเงินค่าธรรมเนียมในการพิจารณาจริยธรรมการวิจัยในมนุษย์</p>
                            }
                        </>
                    }
                </Card>
            </Card>
        </>
    } */}
    <br/>
    {(AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'
    )&&
        <Card>
            <p>หมายเหตุ : เมื่อมีการเปลี่ยนแปลงข้อมูลในระบบ ข้อมูลที่ถูกเปลี่ยนแปลงจะกลายเป็นสีแดงหรือมีข้อความแจ้งในระบบ
                หากมีการเปลี่ยนแปลงข้อมูลไม่ว่าด้วยเหตุใด ให้กรุณาแจ้งกรรมการผ่านฟอร์มข้อโต้แย้งและบันทึกข้อความที่ด้านล่างสุดของโครงการ
            </p>
            <br/>
            <p>หากท่านได้เปลี่ยนแปลงเอกสารเพิ่มเติม ขอความอนุเคราะห์โปรดทำไฮท์ไลท์ในไฟล์ที่ท่านแก้ไขและแจ้งในบันทึกข้อความด้วย</p>
        </Card>}
    <br/>
    <div id="part-1"></div>
    <Flex justify='space-between'><h2>มว.จ. 001 คำขอรับรองการพิจารณาจริยธรรมการวิจัยในมนุษย์ </h2><h2>
        <a href="/VU_HREC/EhticalReq"><Button disabled={editable}>แก้ไขข้อมูล</Button></a></h2></Flex>
    <Card>
        <h2>1.1 ข้อมูลเบื้องต้น</h2>
        <hr/>
        <Row>
            <Col span={12}>
            <p>
            <span style={{ fontWeight: 'bold' }}>ชื่อโครงการวิจัย (ภาษาไทย) :</span>{' '}
            <span
                style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        ) &&
                    AllData?.project_nameTH !== HisAllData?.project_nameTH
                    ? '#FFCE1B'
                    : 'black',
                }}
            >
                {AllData?.project_nameTH || 'ยังไม่กรอกข้อมูล'}
            </span>
            </p>
                
            </Col>
            <Col span={12}>
                <p><span style={{ fontWeight: 'bold' }}>ชื่อโครงการวิจัย (ภาษาอังกฤษ) :</span> {' '}
            <span
                style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        ) &&
                    AllData?.project_nameEN !== HisAllData?.project_nameEN
                    ? '#FFCE1B'
                    : 'black',
                }}
            >{AllData?.project_nameEN||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
            </Col>
        </Row>
        <p> <span style={{ fontWeight: 'bold' }}>ชื่อหัวหน้าโครงการวิจัย :</span>{' '}
                    <span
                        style={{
                        color:
                            AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา' && 
                            AllData?.researcher_THname !== HisAllData?.researcher_THname
                            ? '#FFCE1B'
                            : 'black',  
                        }}
                    >{HeadResData?.researcher_THname||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span>({' '}
                        <span
                            style={{
                            color:
                                AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา' && 
                                AllData?.researcher_ENname !== HisAllData?.researcher_ENname
                                ? '#FFCE1B'
                                : 'black',  
                            }}
                        >{HeadResData?.researcher_ENname||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span>)</p>
        <p> <span style={{ fontWeight: 'bold' }}>ตำแหน่งหัวหน้าโครงการวิจัย: </span>{HeadResData?.posname||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
        <p> <span style={{ fontWeight: 'bold' }}>สังกัดหัวหน้าโครงการวิจัย : </span>{HeadResData?.researcher_facility||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
        <p> <span style={{ fontWeight: 'bold' }}>เบอร์โทรศัพท์ติดต่อหัวหน้าโครงการวิจัย :</span>  {HeadResData?.researcher_phone||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>} </p>
        <p> <span style={{ fontWeight: 'bold' }}>Email หัวหน้าโครงการวิจัย :</span>  {HeadResData?.researcher_email||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
        <br/>
        {JoinedData.map((item, idx) => (
            <>
            <Card key={idx}>
                <p><span style={{ fontWeight: 'bold' }}>ชื่อผู้ร่วมวิจัย :</span> {item?.researcher_THname} ({item?.researcher_ENname})</p>
                <p><span style={{ fontWeight: 'bold' }}>ตำแหน่งผู้ร่วมวิจัย :</span>  {item?.posname} </p>
                <p><span style={{ fontWeight: 'bold' }}>สังกัดผู้ร่วมวิจัย</span> {item?.researcher_facility}</p>
                <p><span style={{ fontWeight: 'bold' }}>สัดส่วนภาระงานร้อยละ</span> {item?.join_per}</p>
                <p><span style={{ fontWeight: 'bold' }}>เบอร์โทรศัพท์ติดต่อผู้ร่วมวิจัย</span> {item?.researcher_phone}</p>
                <p><span style={{ fontWeight: 'bold' }}>Emailผู้ร่วมวิจัย</span> {item?.researcher_email}</p>
            </Card>
            <br/></>
        ))}
        <p style={{ fontWeight: 'bold' }}>สัดส่วนภาระงาน (กรณีที่มีการตีพิมพ์ในวารสาร)</p>
        {AllData?.IsJoinPer=='false'&&<Table columns={[
            {
                title:'ลำดับ',
                width:'5vw',
                key:'order_id',
                dataIndex:'order_id'
            },
            {
                title:'ชื่อผู้มีส่วนร่วม',
                key:'researcher_THname',
                dataIndex:'researcher_THname'
            },
            {
                title: 'สัดส่วนภาระงานร้อยละ',
                key: 'join_per',
                dataIndex: 'join_per',
                width:'10vw',
            
            },
            ]}
            dataSource={participants}
            />||<p style={{marginLeft:20}}>ไม่สามารถจัดแบ่งได้เพราะเป็นการวิจัยแบบพหุสถาบัน/หลายประเทศ</p>
            }
        {(facData?.Pos_NameTH!='เจ้าหน้าที่'&&facData?.Pos_NameTH!='อาจารย์')&&<>
            <p>
                <span style={{ fontWeight: 'bold' }}>ชื่ออาจารย์ที่ปรึกษา :</span> {' '}
                    <span
                        style={{
                        color:
                            (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                            AllData?.advice_Name !== HisAllData?.advice_Name
                            ? '#FFCE1B'
                            : 'black',
                        }}
                    >
                        {AllData?.advice_Name
                        ||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}
                    </span>
                </p>
                
        <p><span style={{ fontWeight: 'bold' }}>สังกัดอาจารย์ที่ปรึกษา :</span> {' '}
                    <span
                        style={{
                        color:
                            (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        ) &&
                            AllData?.advice_fac !== HisAllData?.advice_fac
                            ? '#FFCE1B'
                            : 'black',
                        }}
                    >
                        {AllData?.advice_fac||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}
                    </span> </p>
        <p><span style={{ fontWeight: 'bold' }}>เบอร์โทรศัพท์ติดต่ออาจารย์ที่ปรึกษา :</span> {' '}
                    <span
                        style={{
                        color:
                           (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                            AllData?.advice_PhoneNum !== HisAllData?.advice_PhoneNum
                            ? '#FFCE1B'
                            : 'black',
                        }}
                    >
                        {AllData?.advice_PhoneNum||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}
                    </span></p>
        <p><span style={{ fontWeight: 'bold' }}>Emailอาจารย์ที่ปรึกษา :</span>{' '}
                        <span
                            style={{
                            color:
                               (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                                AllData?.advice_Email !== HisAllData?.advice_Email
                                ? '#FFCE1B'
                                : 'black',
                            }}
                        >
                            {AllData?.advice_Email||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}
                        </span>
                     </p></>}

        <br/>
        {(facData?.Pos_NameTH!='เจ้าหน้าที่'&&facData?.Pos_NameTH!='อาจารย์')&&
            <>
                {AllData?.IsAcademicResearch=='ใช่'&&<p>โครงการนี้เป็นโครงการวิจัยเพื่อการศึกษา</p>
                ||AllData?.IsAcademicResearch=='ไม่ใช่'&&<p>โครงการนี้ไม่เป็นโครงการวิจัยเพื่อการศึกษา</p>
                ||<p>โครงการนี้ยังไม่ระบุว่าเป็นโครงการวิจัยเพื่อการศึกษาหรือไม่</p>}
            </>}
        <p><span style={{ fontWeight: 'bold' }}>โครงการนี้เป็นโครงการวิจัยประเภท :</span> {' '}
            <span
                style={{
                color:
                    (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
            )  &&
                    AllData?.project_type !== HisAllData?.project_type
                    ? '#FFCE1B'
                    : 'black',
                }}
            >
                {AllData?.project_type||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}
            </span></p>
        <p>
            <span style={{ fontWeight: 'bold' }}>ผู้วิจัยมีโครงร่างงานวิจัย และแบบสอบถาม หรือเครื่องมือวิจัย เพื่อประกอบการพิจารณาจริยธรรมการวิจัยในมนุษย์หริอไม่</span>
            </p>
        {AllData?.IsQuestionair=='ไม่มี'&&
            <p style={{marginLeft:20}}>
                <span
                style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.IsQuestionair !== HisAllData?.IsQuestionair
                    ? '#FFCE1B'
                    : 'black',
                }}
            >
                {AllData?.IsQuestionair}</span>{' '}เพราะ{' '}
                <span
                style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.IsQuestionairReason !== HisAllData?.IsQuestionairReason
                    ? '#FFCE1B'
                    : 'black',
                }}
            >{AllData?.IsQuestionairReason
            ||<p>ยังไม่กรอก</p>}</span></p>||
            AllData?.IsQuestionair=='มี'&&<p>{AllData?.IsQuestionair}</p>||
            <p style={{marginLeft:20}}>ยังไม่กรอกข้อมูลแล้ว</p>
        }

        <br/>
        <h3>ระยะเวลา</h3>
        <Card>
            <p>ระยะเวลาที่ดำเนินโครงการวิจัย{' '}<span
                style={{
                color:
                    (   AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                    )&& 
                    (
                        AllData?.ResearchPeriod_year !== HisAllData?.ResearchPeriod_year
                    )
                    ? '#FFCE1B'
                    : 'black',  
                }}
            >{AllData?.ResearchPeriod_year||0}</span> ปี{' '}<span
                style={{
                color:
                    (   AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                    )&& 
                    (
                        AllData?.ResearchPeriod_month !== HisAllData?.ResearchPeriod_month
                    )
                    ? '#FFCE1B'
                    : 'black',  
                }}
                >{AllData?.ResearchPeriod_month||0}</span> เดือน</p>
            <p>
                เริ่มตั้งแต่เดือน{' '}<span
                    style={{
                        color:
                            (   AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                            )&& 
                            (
                                AllData?.ResearchStartingDate !== HisAllData?.ResearchStartingDate
                            )
                            ? '#FFCE1B'
                            : 'black',  
                        }}>
                    {
                    moment(AllData?.ResearchStartingDate).isValid()
                    ? moment(AllData?.ResearchStartingDate)
                        .add(543, 'year')
                        .format('MMMM YYYY')
                    : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                }</span>{' '}จนถึงเดือน{' '}<span style={{
                    color:
                        (   AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                            AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )&& 
                        (
                            AllData?.ResearchEndingDate !== HisAllData?.ResearchEndingDate
                        )
                        ? '#FFCE1B'
                        : 'black',  
                    }}>{
                    moment(AllData?.ResearchEndingDate).isValid()
                    ? moment(AllData?.ResearchEndingDate)
                        .add(543, 'year')
                        .format('MMMM YYYY')
                    : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                }</span>
            </p>
            {   (
                AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                )&& 
                (HisAllData?.ResearchStartingDate!=AllData?.ResearchStartingDate||
                HisAllData?.ResearchEndingDate!=AllData?.ResearchEndingDate)
            &&
                <p style={{color:'gray'}}>(ข้อมูลเดิมคือ เริ่มตั้งแต่เดือน{
                    moment(HisAllData?.ResearchStartingDate).isValid()
                    ? moment(HisAllData?.ResearchStartingDate)
                        .add(543, 'year')
                        .format('MMMM YYYY')
                    : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                }{' '}จนถึงเดือน {moment(AllData?.ResearchEndingDate).isValid()
                    ? moment(AllData?.ResearchEndingDate).add(543, 'year').format('MMMM YYYY')
                    : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                })</p>
            }
            <p>ระยะเวลาที่ดำเนินการเก็บข้อมูล{' '}<span
                    style={{
                        color:
                            (   AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                            )&& 
                            (
                                AllData?.InfoGatheringPeriod_year !== HisAllData?.InfoGatheringPeriod_year
                            )
                            ? '#FFCE1B'
                            : 'black',  
                        }}>{AllData?.InfoGatheringPeriod_year||0}</span> ปี{' '}<span
                        style={{
                            color:
                                (   AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                    AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                )&& 
                                (
                                    AllData?.InfoGatheringPeriod_month !== HisAllData?.InfoGatheringPeriod_month
                                )
                                ? '#FFCE1B'
                                : 'black',  
                            }}>{AllData?.InfoGatheringPeriod_month||0}</span> เดือน</p>
                <p>เริ่มตั้งแต่เดือน{' '}<span
                    style={{
                        color:
                            (   AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                            )&& 
                            (
                                AllData?.ResearchStartingDate !== HisAllData?.ResearchStartingDate
                            )
                            ? '#FFCE1B'
                            : 'black',  
                        }}>{moment(AllData?.InfoGatheringStartingDate).isValid()
                    ? moment(AllData?.InfoGatheringStartingDate).add(543, 'year').format('MMMM YYYY')
                    : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                }</span> จนถึงเดือน{' '}<span
                style={{
                    color:
                        (   AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                            AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )&& 
                        (
                            AllData?.InfoGatheringEndingDate !== HisAllData?.InfoGatheringEndingDate
                        )
                        ? '#FFCE1B'
                        : 'black',  
                    }}>{moment(AllData?.InfoGatheringEndingDate).isValid()
                    ? moment(AllData?.InfoGatheringEndingDate).add(543, 'year').format('MMMM YYYY')
                    : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                }</span></p>
            {
                (
                    AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                    AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                    )&&
            (HisAllData?.InfoGatheringStartingDate!=AllData?.InfoGatheringStartingDate||
                HisAllData?.InfoGatheringEndingDate!=AllData?.InfoGatheringEndingDate
            )
            &&
                <p style={{color:'gray'}}>(ข้อมูลเดิมคือ เริ่มตั้งแต่เดือน{
                    moment(HisAllData?.ResearchStartingDate).isValid()
                    ? moment(HisAllData?.ResearchStartingDate)
                        .add(543, 'year')
                        .format('MMMM YYYY')
                    : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                }{' '}จนถึงเดือน {moment(AllData?.InfoGatheringEndingDate).isValid()
                    ? moment(AllData?.InfoGatheringEndingDate).add(543, 'year').format('MMMM YYYY')
                    : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                })</p>
            }
        </Card>

        <br/>
        <h3>งบประมาณ</h3>
        <p>งบประมาณโครงการวิจัย{' '}<span
                style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.Projectfund !== HisAllData?.Projectfund
                    ? '#FFCE1B'
                    : 'black',
                }}
            >{AllData?.Projectfund||'0'}</span>{' '}บาท</p>
        <p style={{fontWeight:'bold'}}>ค่าธรรมเนียมการพิจารณาจริยธรรมฯ</p>
        <p style={{marginLeft:20}}><span
                style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.EthicalApprovalFee !== HisAllData?.EthicalApprovalFee
                    ? '#FFCE1B'
                    : 'black',
                }}
            >{AllData?.EthicalApprovalFee||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
        <p style={{fontWeight:'bold'}}>แหล่งทุนสนับสนุน (Sponsor)</p>
        <p style={{marginLeft:20}}><span
                style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.Sponsor !== HisAllData?.Sponsor
                    ? '#FFCE1B'
                    : 'black',
                }}
            >{AllData?.Sponsor&& <>{
                AllData?.Sponsor=='อื่นๆ'&&<>{AllData?.SponsorNote}</>||<>{AllData?.Sponsor}</>
            }
        </>||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
        <p style={{color:'gray',marginLeft:20}}>หมายเหตุ : <span
                style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.SponsorNote !== HisAllData?.SponsorNote
                    ? '#FFCE1B'
                    : 'black',
                }}
            >{AllData?.SponsorNote||<span style={{color:'red'}}>ไม่มีข้อมูล</span>}</span></p>
    </Card>
    <br/>
    <Card>
        <h2>1.2 การพิจารณาจริยธรรม</h2>
        <Card>
            <p>ผู้ที่จะได้รับเชิญเป็นผู้ร่วมโครงการวิจัย</p>

                {   ((NewinvitedParticipant.normal&&NewinvitedParticipant.normal.count!=null)
                        ||(NewinvitedParticipant.kids&&NewinvitedParticipant.kids?.count!=null)
                        ||(NewinvitedParticipant.vulnerable&&NewinvitedParticipant.vulnerable.count!=null))
                        &&
                            <>
                                    {(NewinvitedParticipant.normal&&NewinvitedParticipant.normal.count!=null)&&
                                <>
                                <Card>
                                    <h3>อาสาสมัครทั่วไป</h3>
                                    <p> <span style={{ fontWeight: 'bold', width: '5vw' }}>จำนวน</span> {' '}<span
                                        style={{
                                            color:
                                            (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                            AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                            )  &&
                                            (
                                                !NewinvitedParticipantHistory || 
                                                NewinvitedParticipantHistory.normal?.count !== NewinvitedParticipant.normal?.count
                                            )
                                                ? '#FFCE1B'
                                                : 'black',
                                        }}
                                        >{NewinvitedParticipant.normal.count}</span> คน</p>
                                        <p><span style={{fontWeight:'bold'}}>อายุ :</span> 
                                        <span
                                            style={{
                                                color:
                                                (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                                AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                                )  &&
                                                    (
                                                        !NewinvitedParticipantHistory || 
                                                        NewinvitedParticipantHistory.normal?.age !== NewinvitedParticipant.normal.age
                                                    )
                                                        ? '#FFCE1B'
                                                        : 'black',
                                                }}>{NewinvitedParticipant.normal.age}</span> </p>
                                            <p>
                                                <span style={{fontWeight:'bold'}}>เพศ</span>{' '}<span
                                                    style={{
                                                        color:
                                                        (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                                            AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                                            )  &&
                                                            !arraysHaveSameMembers(
                                                                NewinvitedParticipant.normal?.gender || [],
                                                                NewinvitedParticipantHistory.normal?.gender || []
                                                                )
                                                        
                                                            ? '#FFCE1B'
                                                            : 'black',
                                                    }}>{NewinvitedParticipant.normal.gender.join(', ')}</span>
                                            </p>
                                            <p> <span style={{fontWeight:'bold'}}>หมายเหตุ</span>{' '}<span
                                                style={{
                                                    color:
                                                    (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                                    AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                                    )  &&
                                                    (
                                                        !NewinvitedParticipantHistory.normal || 
                                                        NewinvitedParticipantHistory.normal.note !== NewinvitedParticipant.normal.note
                                                    )
                                                        ? '#FFCE1B'
                                                        : 'black',
                                                }}>{NewinvitedParticipant.normal.note}</span></p>
                                    </Card>
                                <br/></>
                                    }


                                      {(NewinvitedParticipant.kids&&NewinvitedParticipant.kids?.count!=null)&&
                                <>
                                <Card>
                                    <h3>อาสาสมัครเด็ก อายุ 7-18 ปี</h3>
                                    <p> <span style={{ fontWeight: 'bold', width: '5vw' }}>จำนวน</span> {' '}<span
                                        style={{
                                            color:
                                            (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                            AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                            )  &&
                                            (
                                                !NewinvitedParticipantHistory || 
                                                NewinvitedParticipantHistory.kids?.count !== NewinvitedParticipant.kids?.count
                                            )
                                                ? '#FFCE1B'
                                                : 'black',
                                        }}
                                        >{NewinvitedParticipant.kids?.count}</span> คน</p>
                                        <p><span style={{fontWeight:'bold'}}>อายุ :</span> 
                                        <span
                                            style={{
                                                color:
                                                (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                                AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                                )  &&
                                                    (
                                                        !NewinvitedParticipantHistory || 
                                                        NewinvitedParticipantHistory.kids?.age !== NewinvitedParticipant.kids?.age
                                                    )
                                                        ? '#FFCE1B'
                                                        : 'black',
                                                }}>{NewinvitedParticipant.kids?.age}</span> </p>
                                            <p>
                                                <span style={{fontWeight:'bold'}}>เพศ</span>{' '}<span
                                                    style={{
                                                        color:
                                                        (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                                            AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                                            )  &&
                                                            !arraysHaveSameMembers(
                                                                NewinvitedParticipant.kids?.gender || [],
                                                                NewinvitedParticipantHistory.kids?.gender || []
                                                                )
                                                        
                                                            ? '#FFCE1B'
                                                            : 'black',
                                                    }}>{NewinvitedParticipant.kids?.gender.join(', ')}</span>
                                            </p>
                                            <p> <span style={{fontWeight:'bold'}}>หมายเหตุ</span>{' '}<span
                                                style={{
                                                    color:
                                                    (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                                    AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                                    )  &&
                                                    (
                                                        !NewinvitedParticipantHistory.kids || 
                                                        NewinvitedParticipantHistory.kids.note !== NewinvitedParticipant.kids?.note
                                                    )
                                                        ? '#FFCE1B'
                                                        : 'black',
                                                }}>{NewinvitedParticipant.kids?.note}</span></p>
                                        </Card>
                                <br/></>
                                    }
                                     {(NewinvitedParticipant.vulnerable&&NewinvitedParticipant.vulnerable?.count!=null)&&
                                <>
                                <Card>
                                    <h3>อาสาสมัครกลุ่มเปราะบาง</h3>
                                    <p> <span style={{ fontWeight: 'bold', width: '5vw' }}>จำนวน</span> {' '}<span
                                        style={{
                                            color:
                                            (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                            AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                            )  &&
                                            (
                                                !NewinvitedParticipantHistory || 
                                                NewinvitedParticipantHistory.vulnerable?.count !== NewinvitedParticipant.vulnerable?.count
                                            )
                                                ? '#FFCE1B'
                                                : 'black',
                                        }}
                                        >{NewinvitedParticipant.vulnerable?.count}</span> คน</p>
                                        <p><span style={{fontWeight:'bold'}}>อายุ :</span> 
                                        <span
                                            style={{
                                                color:
                                                (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                                AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                                )  &&
                                                    (
                                                        !NewinvitedParticipantHistory || 
                                                        NewinvitedParticipantHistory.vulnerable?.age !== NewinvitedParticipant.vulnerable?.age
                                                    )
                                                        ? '#FFCE1B'
                                                        : 'black',
                                                }}>{NewinvitedParticipant.vulnerable?.age}</span> </p>
                                            <p>
                                                <span style={{fontWeight:'bold'}}>เพศ</span>{' '}<span
                                                    style={{
                                                        color:
                                                        (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                                            AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                                            )  &&
                                                            !arraysHaveSameMembers(
                                                                NewinvitedParticipant.vulnerable?.gender || [],
                                                                NewinvitedParticipantHistory.vulnerable?.gender || []
                                                                )
                                                        
                                                            ? '#FFCE1B'
                                                            : 'black',
                                                    }}>{NewinvitedParticipant.vulnerable?.gender.join(', ')}</span>
                                            </p>
                                            <p> <span style={{fontWeight:'bold'}}>หมายเหตุ</span>{' '}<span
                                                style={{
                                                    color:
                                                    (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                                    AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                                    )  &&
                                                    (
                                                        !NewinvitedParticipantHistory.vulnerable || 
                                                        NewinvitedParticipantHistory.vulnerable.note !== NewinvitedParticipant.vulnerable?.note
                                                    )
                                                        ? '#FFCE1B'
                                                        : 'black',
                                                }}>{NewinvitedParticipant.vulnerable?.note}</span></p>
                                        </Card>
                                <br/></>
                                    }
                            </>
                            ||<>
                                <Card>
                                    <p style={{color:'red'}}>ยังไม่มีการเพิ่มข้อมูล</p>
                                </Card></>}
                
        </Card>
        <br/>
        <p  style={{fontWeight:'bold'}}>การเจาะเลือดผู้ป่วย/อาสาสมัครหริอไม่ </p>
        <div style={{ marginLeft: 20 }}>
            <span style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.IsbloodDraw !== HisAllData?.IsbloodDraw
                    ? '#FFCE1B'
                    : 'black',
                }}>
            {AllData?.IsbloodDraw === 'มี' ? (
                <p>มี มีรายละเอียดดังนี้</p>
            ) : AllData?.IsbloodDraw ? (
                <p>{AllData.IsbloodDraw}</p>
            ) : (
                <p style={{ color: 'red' }}>ยังไม่มีการลงข้อมูล</p>
            )}</span>
            </div>
        {AllData?.IsbloodDraw=='มี'&&
            <Card style={{marginLeft:20}}>
                <p style={{fontWeight:'bold'}}>วัตถุประสงค์ของการเจาะเลือด</p>
                <span
                    style={{
                        color:
                           (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                            AllData?.bloodDrawObjective !== HisAllData?.bloodDrawObjective
                            ? '#FFCE1B'
                            : 'black',
                        }}>
                    <p
                        style={{ fontSize: '16px', marginLeft: 20 }}
                        dangerouslySetInnerHTML={{ 
                            __html: (AllData?.bloodDrawObjective || 'ยังไม่กรอกข้อมูล').replace(/\n/g, '<br/>') 
                        }}
                        /></span>
                <Row>
                    <Col span={12}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ fontWeight: 'bold', width: '5vw' }}>จำนวน</span>
                        <span style={{
                            color:
                               (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                                AllData?.bloodDrawTimes !== HisAllData?.bloodDrawTimes
                                ? '#FFCE1B'
                                : 'black',
                            }}>{AllData?.bloodDrawTimes}</span>
                        <span style={{ fontWeight: 'bold', marginLeft: '3vw' }}>ครั้ง</span>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ fontWeight: 'bold', width: '5vw' }}>ครั้งละ</span>
                        <span  style={{
                            color:
                               (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                                AllData?.bloodDrawAmount !== HisAllData?.bloodDrawAmount
                                ? '#FFCE1B'
                                : 'black',
                            }}>{AllData?.bloodDrawAmount}</span>
                        <span style={{ color:
                               (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                                AllData?.bloodDrawUnit !== HisAllData?.bloodDrawUnit
                                ? '#FFCE1B'
                                : 'black',fontWeight: 'bold', marginLeft: '3vw' }}>{AllData?.bloodDrawUnit|| 'ยังไม่กรอก'}</span>
                        </div>
                    </Col>
                    </Row>

                    <Row>
                    <Col span={12}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ fontWeight: 'bold', width: '5vw' }}>ทั้งหมด</span>
                        <span style={{
                            color:
                               (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                                AllData?.bloodDrawTotalTimes !== HisAllData?.bloodDrawTotalTimes
                                ? '#FFCE1B'
                                : 'black',
                            }}>{AllData?.bloodDrawTotalTimes}</span>
                        <span style={{ fontWeight: 'bold', marginLeft: '3vw' }}>ครั้ง</span>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ fontWeight: 'bold', width: '5vw' }}>ต่อ</span>
                        <span style={{
                            color:
                               (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                                AllData?.bloodDrawTotalMonth !== HisAllData?.bloodDrawTotalMonth
                                ? '#FFCE1B'
                                : 'black',
                            }}>{AllData?.bloodDrawTotalMonth}</span>
                        <span style={{ fontWeight: 'bold', marginLeft: '3vw' }}>เดือน</span>
                        </div>
                    </Col>
                    </Row>

               
            </Card>}
        <p  style={{fontWeight:'bold'}}>หัตถการอื่นที่มีการรุกล้ำร่างกาย (Invasive Procedure)  </p>
        <div style={{ marginLeft: 20 }}>
            <span
                style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.IsInvasiveProcedure !== HisAllData?.IsInvasiveProcedure
                    ? '#FFCE1B'
                    : 'black',
                }}
            >
                {AllData?.IsInvasiveProcedure === 'มี' ? (
                    <p>มี มีรายละเอียดดังนี้</p>
                ) : AllData?.IsInvasiveProcedure ? (
                    <p
                        style={{ fontSize: '16px', marginLeft: 20 }}
                        dangerouslySetInnerHTML={{ 
                            __html: (AllData?.IsInvasiveProcedure || 'ยังไม่กรอกข้อมูล').replace(/\n/g, '<br/>') 
                        }}
                        />
                ) : (
                    <span style={{ color: 'red' }}>ยังไม่มีการลงข้อมูล</span>
                )}</span>
        </div>
        {AllData?.IsInvasiveProcedure == 'มี'&&
        <Card style={{marginLeft:20}}>
            <span
                style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.InvasiveProcedureSummary !== HisAllData?.InvasiveProcedureSummary
                    ? '#FFCE1B'
                    : 'black',
                }}
            >
            <p
                style={{ fontSize: '16px', marginLeft: 20 }}
                dangerouslySetInnerHTML={{ 
                    __html: (AllData?.InvasiveProcedureSummary || 'ยังไม่กรอกข้อมูล').replace(/\n/g, '<br/>') 
                }}
                /></span>
           </Card>
        }
        <p style={{fontWeight:'bold'}}>ความเสี่ยงและความไม่สะดวกสบายที่ผู้ป่วย/อาสาสมัคร จะได้รับจากการร่วมโครงการ</p>
        
        <span
                style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.RiskAndUncomfortableFactor !== HisAllData?.RiskAndUncomfortableFactor
                    ? '#FFCE1B'
                    : 'black',
                }}
            >
                {AllData?.RiskAndUncomfortableFactor ? (
                    <p
                        style={{ fontSize: '16px', marginLeft: 20 }}
                        dangerouslySetInnerHTML={{
                        __html: AllData.RiskAndUncomfortableFactor.replace(/\n/g, '<br/>'),
                        }}
                    />
                    ) : (
                    <p style={{ fontSize: '16px', marginLeft: 20, color: 'red' }}>
                        ยังไม่มีการลงข้อมูล
                    </p>
                    )}
                 
        </span>
       
            
        <p style={{fontWeight:'bold'}}>วิธีการหรือมาตรการที่จัดเตรียมเพื่อลดความเสี่ยงและความไม่สะดวกสบายที่ผู้ป่วย/อาสาสมัคร จะได้รับจากการร่วมโครงการ </p>
        <p style={{marginLeft:20}}><span
                style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.DefensiveMeasure !== HisAllData?.DefensiveMeasure
                    ? '#FFCE1B'
                    : 'black',
                }}
            >{AllData?.DefensiveMeasure||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</span></p>
        <p style={{fontWeight:'bold'}}>ถ้าหากเกิดอันตราย/ความเสียหายต่อผู้ถูกวิจัย ที่เป็นผลสืบเนื่องโดยตรงจากการวิจัยในผู้ป่วย ผู้เสนอโครงการและ/หรือผู้ให้ทุนสนับสนุน
            การวิจัยจะให้การรักษาจนกลับคืนสภาพเดิม หรือชดเชยความเสียหายที่ไม่สามารถรักษาให้คืนสู่สภาพเดิมได้ ตลอดจน
            ให้ความคุ้มครองด้านค่าใช้จ่ายแก่ผู้ถูกวิจัยอย่างไรบ้าง?</p>
            <p style={{marginLeft:20}}><span
                style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.ExpenseCoverage !== HisAllData?.ExpenseCoverage
                    ? '#FFCE1B'
                    : 'black',
                }}
            >{AllData?.ExpenseCoverage||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</span></p>
        
        <p style={{fontWeight:'bold'}}>ผู้วิจัยและผู้ร่วมงานทุกคนในโครงการทราบโดยผ่านการอบรมจริยธรรมการวิจัยในมนุษย์และเข้าใจข้อตกลง หลักความเคารพ
        ในบุคคล หลักคุณประโยชน์ และหลักความยุติธรรม  หรือไม่ </p>
        <p style={{marginLeft:20}}><span
                style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.AcceptanceUnderstanding !== HisAllData?.AcceptanceUnderstanding
                    ? '#FFCE1B'
                    : 'black',
                }}
            >{AllData?.AcceptanceUnderstanding||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</span></p>
        <p style={{fontWeight:'bold'}}>โครงการวิจัยเกี่ยวข้องหรืออาจมีผลกระทบกระเทือนต่อศาสนา ความเชื่อ ขนบธรรมเนียมประเพณี หรือ วัฒนธรรมอันดีงามของประเทศไทย หรือของท้องถิ่นที่ทำการวิจัยอยู่หรือไม่</p>
        <p style={{marginLeft:20}}><span
                style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.IsCountryReligionRiskFactor !== HisAllData?.IsCountryReligionRiskFactor
                    ? '#FFCE1B'
                    : 'black',
                }}
            >{AllData?.IsCountryReligionRiskFactor||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</span></p>
        {AllData?.IsInvasiveProcedure&&<>
            <p> <span
                style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.CountryReligionRiskFactor !== HisAllData?.CountryReligionRiskFactor
                    ? '#FFCE1B'
                    : 'black',
                }}
            >{AllData?.CountryReligionRiskFactor}</span></p></>
        }
        <br/>
    
    </Card>
        <br/>
    <Card>
        <h2>1.3 ยา</h2>

        <p style={{fontWeight:'bold'}}>โครงการวิจัยนี้มีการให้ยาและหรือสิ่งทดลอง (เช่น โปรแกรมการส่งเสริมสุขภาพ การนวด การใช้สมุนไพร เป็นต้น) แก่ผู้ป่วย/อาสาสมัครหรือไม่ </p>
        <p style={{marginLeft:20}}>
        <span
            style={{
            color:
                (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                    AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                    )  &&
                AllData?.IsMedicine !== HisAllData?.IsMedicine
                ? '#FFCE1B'
                : 'black',
            }}
        >{AllData?.IsMedicine||'ยังไม่กรอกข้อมูล'}</span></p>
        {AllData?.IsMedicine=='มี'&&
            <p style={{marginLeft:20}}><span
            style={{
            color:
               (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                    AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                    )  &&
                AllData?.MedicineInfo !== HisAllData?.MedicineInfo
                ? '#FFCE1B'
                : 'black',
            }}
        >ได้แก่ {AllData?.MedicineInfo}</span></p>}
        

        <span style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.applicableFactor !== HisAllData?.applicableFactor
                    ? '#FFCE1B'
                    : 'black',
                }}>{AllData?.applicableFactor!='ไม่เกี่ยวข้องกับรายการข้างต้น'&&
                <p  style={{fontWeight:'bold'}}>โครงการวิจัยนี้เกี่ยวข้องกับ </p>}
        {AllData?.applicableFactor && AllData.applicableFactor !== "[]" ? (
            <div style={{ marginLeft: 20 }}>
                {JSON.parse(AllData.applicableFactor).map((item:any, idx:any) => (
                <div key={idx}>- {item}</div>
                ))}
            </div>
            ) : (
            <p style={{ marginLeft: 20, color: 'red' }}>ยังไม่กรอกข้อมูล</p>
            )}</span>
        {AllData?.applicableFactorDesc&&<p style={{marginLeft:20}}>คำอธิบายประกอบ : <span style={{color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.applicableFactorDesc !== HisAllData?.applicableFactorDesc
                    ? '#FFCE1B'
                    : 'black',}}>{AllData?.applicableFactorDesc}</span></p>}
    </Card>
    <br/>
    <Card>
        <h2>1.4 ทรัพย์สินทางปัญญาและอื่น ๆ</h2>

        <p style={{fontWeight:'bold'}}>ผลของการศึกษาวิจัย (Results) หรือวัสดุใด ๆ (Materials) ที่เก็บจากผู้ป่วยหรือที่จะเป็นผลลัพธ์จากการวิจัยอาจมีคุณค่าในแง่ทรัพย์สินทาง
        การค้าและ/หรือทรัพย์สินทางปัญญา (เช่น สิทธิบัตร) หรือไม่ อย่างไร </p>
        <span style={{
           color:
          (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
           AllData?.IsCommercialInterlectualProperty !== HisAllData?.IsCommercialInterlectualProperty
           ? '#FFCE1B'
           : 'black',
        }}>
        {AllData?.IsCommercialInterlectualProperty=='มี'&&<p style={{marginLeft:20}}>มี ดังนี้ {AllData?.ComIntDesc}</p>|| 
        <p style={{marginLeft:20}}>{AllData?.IsCommercialInterlectualProperty ||
            <span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</p>}</span>
        <p style={{fontWeight:'bold'}}>ผู้วิจัยจะส่งรายงานความก้าวหน้า (Progress Report) มายังคณะกรรมการเมื่อ</p>
        <span style={{
           color:
          (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
           AllData?.ProgressReport !== HisAllData?.ProgressReport
           ? '#FFCE1B'
           : 'black',
        }}>
            <p style={{marginLeft:20}}>{AllData?.ProgressReport||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</p>
        </span>
        <p style={{fontWeight:'bold'}}>การเขียนทบทวนวรรณกรรม การนำผลงาน ข้อความ หรือความคิดเห็นของผู้อื่น มาดัดแปลง ตัดต่อ หรือแก้ไข (บางส่วนหรือทั้งหมด) ทำซ้ำกับบุคคลอื่น ไม่เกิน 30 %  </p>
        <span style={{
           color:
          (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
            AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
            )  &&
           AllData?.PlagiarismPer !== HisAllData?.PlagiarismPer
           ? '#FFCE1B'
           : 'black',
        }}>{AllData?.PlagiarismPer=='ไม่ใช่'&&<p  style={{marginLeft:20}}>{AllData?.PlagiarismPer}</p>}
        {AllData?.PlagiarismPer&&<p  style={{marginLeft:20}}>{AllData?.PlagiarismPer} </p>}</span>
      
    </Card>
    <br/>
    <Card>
        <h2>1.5 คำรับรองจากผู้วิจัย</h2>
        {AllData?.Acceptance=='รับรอง'
        &&<>
        <p>ในการดำเนินการวิจัยในครั้งนี้ ข้าพเจ้าขอรับรองว่า</p>
        <p>1. ข้าพเจ้าได้ตรวจสอบความถูกต้องของข้อมูลทั้งหมดที่นำเสนอต่อคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุลด้วยตนเอง</p>
        <p>2. ข้าพเจ้าจะไม่เริ่มดำเนินการวิจัยจนกว่าจะได้รับผลการพิจารณาจากคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุล </p>
        <p>3. ข้าพเจ้าทราบว่าหากมีการแก้ไข/ปรับปรุงโครงการวิจัย นอกเหนือจากที่ยื่นขอรับการพิจารณาครั้งนี้ ข้าพเจ้าจะต้องรายงาน โดยใช้แบบฟอร์ม มว.จ.011 หรือ มว.จ.012 หรือ มว.จ.013 </p>
        <p>4. ข้าพเจ้าจะรายงานการแจ้งปิดโครงการวิจัยต่อคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุล โดยใช้แบบฟอร์ม มว.จ.016  เมื่อดำเนินโครงการวิจัยเสร็จสิ้นแล้ว</p></>
        ||AllData?.Acceptance=='ไม่รับรอง'
        &&<div><p  style={{color:'red'}}>ในการดำเนินการวิจัยในครั้งนี้ ข้าพเจ้าไม่รับรองว่า</p>
        <p>1. ข้าพเจ้าได้ตรวจสอบความถูกต้องของข้อมูลทั้งหมดที่นำเสนอต่อคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุลด้วยตนเอง</p>
        <p>2. ข้าพเจ้าจะไม่เริ่มดำเนินการวิจัยจนกว่าจะได้รับผลการพิจารณาจากคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุล </p>
        <p>3. ข้าพเจ้าทราบว่าหากมีการแก้ไข/ปรับปรุงโครงการวิจัย นอกเหนือจากที่ยื่นขอรับการพิจารณาครั้งนี้ ข้าพเจ้าจะต้องรายงาน โดยใช้แบบฟอร์ม มว.จ.011 หรือ มว.จ.012 หรือ มว.จ.013 </p>
        <p>4. ข้าพเจ้าจะรายงานการแจ้งปิดโครงการวิจัยต่อคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุล โดยใช้แบบฟอร์ม มว.จ.016  เมื่อดำเนินโครงการวิจัยเสร็จสิ้นแล้ว</p>
        </div>
        ||
        <><p>ยังไม่มีการยืนยันคำรับรองจากนักวิจัย</p></>}
        <p>ข้าพเจ้าต้องการหนังสือรับรองจากคณะกรรมการเป็นฉบับ</p>
        <Card>
        {AllData?.LangRecieve && AllData.LangRecieve !== "[]" ? (
            JSON.parse(AllData.LangRecieve).join(", ")
        ) : (
            <span style={{ color: 'red' }}>ยังไม่ระบุ</span>
        )}</Card>
    </Card>
    <br/><hr/>
    <div id="part-2"/>
    <Flex justify='space-between'>
        <h2>มว.จ. 002 แบบเอกสารชี้แจงอาสาสมัครเพื่อประกอบการพิจารณาจริยธรรมการวิจัยในมนุษย์</h2>
    <h2><Button href="/VU_HREC/VolunteerForm"
        disabled={editable}
        >แก้ไขข้อมูล</Button>
        {!Part2Status&&
        <Button href="/VU_HREC/VolunteerForm"
        icon={<UploadOutlined />} 
        onClick={() => {
            window.open(`${process.env.REACT_APP_BASE}/generate-te-pdf-pup/${sessionStorage.getItem('Order_ID')}/${sessionStorage.getItem('user')}`, '_blank');
            }}
        >export pdf</Button>}</h2></Flex>
    <Card>
        <p> <span style={{ fontWeight: 'bold' }}>ชื่อโครงการวิจัย : </span>
            <span style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.project_nameTH !== HisAllData?.project_nameTH
                    ? '#FFCE1B'
                    : 'black',
                }}>{AllData?.project_nameTH||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
        <Card>
        <p> <span style={{ fontWeight: 'bold' }}>ชื่อผู้วิจัย : </span> <span style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                        HeadResData?.researcher_THname !== HeadExResData?.researcher_THname
                    ? '#FFCE1B'
                    : 'black',
                }}>{HeadResData?.researcher_THname}</span></p>
        <p> <span style={{ fontWeight: 'bold' }}>ตำแหน่ง : </span><span style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                        HeadResData?.posname !== HeadExResData?.posname
                    ? '#FFCE1B'
                    : 'black',
                }}>{HeadResData?.posname || <span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
        <p> <span style={{ fontWeight: 'bold' }}>สถานที่ติดต่อผู้วิจัย (ที่ทำงาน) : </span><span style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                        HeadResData?.researcher_wp !== HeadExResData?.researcher_wp
                    ? '#FFCE1B'
                    : 'black',
                }}>{HeadResData?.researcher_wp||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
        <p> <span style={{ fontWeight: 'bold' }}>สถานที่ติดต่อผู้วิจัย (บ้าน) : </span><span style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                        HeadResData?.researcher_address !== HeadExResData?.researcher_address
                    ? '#FFCE1B'
                    : 'black',
                }}>{HeadResData?.researcher_address||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
        <p> <span style={{ fontWeight: 'bold' }}>โทรศัพท์ (ที่ทำงาน) : </span><span style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                        HeadResData?.researcher_wptel !== HeadExResData?.researcher_wptel
                    ? '#FFCE1B'
                    : 'black',
                }}>{HeadResData?.researcher_wptel||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
        <p> <span style={{ fontWeight: 'bold' }}>โทรศัพท์ (บ้าน) : </span><span style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                        HeadResData?.researcher_tel !== HeadExResData?.researcher_tel
                    ? '#FFCE1B'
                    : 'black',
                }}>{HeadResData?.researcher_tel||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
        <p> <span style={{ fontWeight: 'bold' }}>โทรศัพท์ (มือถือ) : </span><span style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                        HeadResData?.researcher_phone !== HeadExResData?.researcher_phone
                    ? '#FFCE1B'
                    : 'black',
                }}>{HeadResData?.researcher_phone||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
        <p> <span style={{ fontWeight: 'bold' }}>E-mail : </span><span style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                        HeadResData?.researcher_email !== HeadExResData?.researcher_email
                    ? '#FFCE1B'
                    : 'black',
                }}>{HeadResData?.researcher_email||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
        </Card>
       
        <hr/>
        <p> <span style={{ fontWeight: 'bold' }}>โครงการวิจัยนี้เกี่ยวข้องกับการวิจัย เรื่อง</span> </p>
        <p style={{color:
           (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
            (
                AllData?.relevantTopic !== AllData?.relevantTopic
            )
                ? '#FFCE1B'
                : 'black',marginLeft:20}}>{AllData?.relevantTopic}</p>
        <p> <span style={{ fontWeight: 'bold' }}>วัตถุประสงค์ของการวิจัย</span> </p>
        <p
        style={{ fontSize: '16px', color:
            (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                 AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                 AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                 AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                 )  &&
             AllData?.Objective !== HisAllData?.Objective
             ? '#FFCE1B'
             : 'black',
             marginLeft:20 }}
        dangerouslySetInnerHTML={{ 
            __html: (AllData?.Objective || 'ยังไม่กรอกข้อมูล').replace(/\n/g, '<br/>') 
        }}
        />
        <Card>
            <p style={{fontWeight:'bold'}}><u>รายละเอียดของกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย </u></p>
            <p style={{marginLeft:20,fontWeight:'bold'}}>ลักษณะของกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย  เกณฑ์การคัดเข้า และเกณฑ์การคัดออก: </p>
            <p
                style={{ fontSize: '16px', marginLeft: 20 }}
                dangerouslySetInnerHTML={{ 
                    __html: (AllData?.ParticipantCharacteristicAndCriterion || 'ยังไม่กรอกข้อมูล').replace(/\n/g, '<br/>') 
                }}
                />
         

            <p style={{marginLeft:20,fontWeight:'bold'}}>จำนวนของกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย: </p>
            {(AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                )  &&(AllData?.ParticipantAmount!=HisAllData?.ParticipantAmount)&&<>
                <br/><Card>
                <p style={{color:'rec'}}>ข้อมูลจำนวนของกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัยมีการเปลี่ยนแปลงเป็นผลดั่งด้านล่าง</p>
                </Card><br/></>}
            <ROCKEditors
                myRef={ParticipantAmountRef}
                htmlBox={AllData?.ParticipantAmount ? AllData?.ParticipantAmount : "ยังไม่กรอกข้อมูล"}
                toolstate={false}
                />
            
            <p style={{marginLeft:20,fontWeight:'bold'}}>วิธีการได้มาซึ่งกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย: </p>
            <span
                style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.ParticipantRecruit !== HisAllData?.ParticipantRecruit
                    ? '#FFCE1B'
                    : 'black',
                }}
                ><p style={{marginLeft:40}}>{AllData?.ParticipantRecruit||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
            </span>

            <p style={{marginLeft:20,fontWeight:'bold'}}>เหตุผลที่ได้รับเชิญเข้าร่วมโครงการวิจัย: </p>
            <span
                style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.ParticipantReason !== HisAllData?.ParticipantReason
                    ? '#FFCE1B'
                    : 'black',
                }}
                ><p style={{marginLeft:40}}>{AllData?.ParticipantReason||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
            </span>
        </Card>
        <p style={{fontWeight:'bold'}}>กระบวนการการวิจัยที่กระทำต่อกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย </p>
        {(AllData?.ParticipantProcedure!=HisAllData?.ParticipantProcedure)&&<>
                <br/><Card>
                <p style={{color:'rec'}}>ข้อมูลการแบ่งกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัยมีการเปลี่ยนแปลงเป็นผลดั่งด้านล่าง</p>
        </Card><br/></>}
        <ROCKEditors
                myRef={ParticipantProcedureRef}
                htmlBox={AllData?.ParticipantProcedure ? AllData?.ParticipantProcedure : "ยังไม่กรอกข้อมูล"}
                toolstate={false}
                />


        <p style={{fontWeight:'bold'}}>กระบวนการให้ข้อมูลแก่กลุ่มประชากร หรือผู้มีส่วนร่วมในการวิจัย </p>
        <p style={{ color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.ParticipantAcknowledgementMethod !== HisAllData?.ParticipantAcknowledgementMethod
                    ? '#FFCE1B'
                    : 'black',marginLeft:20}}>{AllData?.ParticipantAcknowledgementMethod||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>

        <Card>
            <p style={{fontWeight:'bold'}}>การใช้เวชระเบียน </p>
            <p style={{marginLeft:20}}>การวิจัยที่ดูข้อมูลจากเวชระเบียนเท่านั้น ต้องได้รับการอนุมัติจากผู้มีอำนาจหน้าที่ เช่น ผู้อำนวยการโรงพยาบาล </p>
            <p style={{color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.MedicalRecordInfoAllowedByHead !== HisAllData?.MedicalRecordInfoAllowedByHead
                    ? '#FFCE1B'
                    : 'black',marginLeft:40}}>{AllData?.MedicalRecordInfoAllowedByHead||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
            <p style={{marginLeft:20}}>การวิจัยที่มีการกระทำต่อผู้ป่วยและใช้เวชระเบียนต้องได้รับการอนุมัติจากผู้มีอำนาจหน้าที่ เช่น ผู้อำนวยการโรงพยาบาลและการยินยอมจากผู้ป่วย: </p>
            <p style={{color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.MedicalRecordactionAllowedByHead !== HisAllData?.MedicalRecordactionAllowedByHead
                    ? '#FFCE1B'
                    : 'black',marginLeft:40}}>{AllData?.MedicalRecordactionAllowedByHead||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
        </Card>
        <p style={{fontWeight:'bold'}}>ข้อมูลเกี่ยวกับอันตรายหรือความเสี่ยงที่อาจเกิดขึ้นแก่กลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย รวมทั้งวิธีการป้องกัน/ปกป้องอันตราย และความเสี่ยงนั้น </p>
        <p style={{color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.RiskAndPrevent !== HisAllData?.RiskAndPrevent
                    ? '#FFCE1B'
                    : 'black',marginLeft:20}}>{AllData?.RiskAndPrevent||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>

        <p style={{fontWeight:'bold'}}>ประโยชน์ในการเข้าร่วมวิจัย: </p>
        <p style={{color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.Benefit !== HisAllData?.Benefit
                    ? '#FFCE1B'
                    : 'black',marginLeft:20}}>{AllData?.Benefit||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>

        <p style={{fontWeight:'bold'}}>การจ่ายค่าพาหนะ ค่าชดเชยการเสียเวลา หรือของที่ระลึก: </p>
        <p style={{color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                    AllData?.Coverage !== HisAllData?.Coverage
                    ? '#FFCE1B'
                    : 'black',marginLeft:20}}>{AllData?.Coverage||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>


    </Card>
    <br/>
    {AllData?.project_status!='แก้ไข'&&<>
        <Flex justify='center'>
            <Button type="primary" icon={<UploadOutlined />} onClick={() => {
                window.open(`${process.env.REACT_APP_BASE}/generate-alldataPDF/${sessionStorage.getItem('Order_ID')}/${sessionStorage.getItem('user')}`, '_blank');
                }}>
                ดาวน์โหลดข้อมูลโครงการ
            </Button>&nbsp;
        </Flex>
    </>}
    <hr/>
    <div id="part-3"></div>
    <h2>แนบเอกสารหลักฐานเพิ่มเติม</h2>
    <Table
        rowClassName={() => 'centered-row'}
        columns={[{
                title:'ลำดับ',
                width:'2vw',
                dataIndex:'id',
                
            },{
                title:'ประเภทเอกสาร',
                dataIndex:'AttachmentType',
                render:(__, record)=> <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center', 
                        height: '100%', 
                    }}
                >
                    {record.Status === 'แนบแล้ว' ? (
                        <a onClick={() => viewFile(record.AttachmentType)}>{record.AttachmentType}</a>
                    ) : (
                        <p style={{marginTop:0,marginBottom:0}}>{record.AttachmentType}</p>
                    )}
                     {(
                        record.AttachmentType === 'เค้าโครงวิจัย 3 บท'
                       
                    ) && (
                        <p style={{ margin: 0,color:'red' }}>( **ต้องอัพโหลด** อัพได้เพียงไฟล์สกุล PDF จำนวน 1 ไฟล์)</p>
                    )}
                    {
                        record.AttachmentType === 'หลักฐานการรับรองคำพิจารณาจริยธรรมจากที่ปรึกษา (สำหรับนักศึกษา)'
                        &&
                        <>
                            <p style={{ margin: 0 , color: 'gray'}}>กรุณาใช้ฟอร์ม <a onClick={() => {
                              window.open(`${process.env.REACT_APP_BASE}/generate-part1/${sessionStorage.getItem('Order_ID')}/${sessionStorage.getItem('user')}`);
                              }}>มว.จ. 001 คำขอรับรองการพิจารณาจริยธรรมการวิจัยในมนุษย์</a>&nbsp;</p>
                            <p style={{ margin: 0,color:'gray' }}>( กรุณากรอกฟอร์ม มว.จ. 001 คำขอรับรองการพิจารณาจริยธรรมการวิจัยในมนุษย์ ให้แล้วเสร็จก่อนโหลดฟอร์ม )</p>
                            <p style={{ margin: 0,color:'gray' }}>( อัพได้เพียงไฟล์สกุล PDF เท่านั้น / ไม่จำกัดจำนวนไฟล์ )</p>
                        </>
                    }
                    {(
                      
                        record.AttachmentType === 'หลักฐานการชำระเงินค่าธรรมเนียมในการพิจารณาจริยธรรมการวิจัยในมนุษย์'
                    ) && (
                        <p style={{ margin: 0,color:'red' }}>( **ต้องอัพโหลด** อัพได้เพียงไฟล์สกุล PDF จำนวน 1 ไฟล์ และต้องใบเสร็จชำระเงินที่ออกโดยมหาวิทยาลัยวงษ์ชลิตกุลเท่านั้น)</p>
                    )}
                    {record.AttachmentType === 'เครื่องมือหรือแบบสอบถาม (ถ้ามี)' && (
                        <p style={{ margin: 0,color:'gray' }}>( อัพได้เพียงไฟล์สกุล PDF เท่านั้น / ไม่จำกัดจำนวนไฟล์ )</p>
                    )}
                    {(record.AttachmentType === 'หนังสือรับรองการประเมินคุณภาพเครื่องมือวิจัย(ถ้ามี)'
                    ||record.AttachmentType === 'เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครทั่วไป (ถ้าเกี่ยวข้อง)'
                    ||record.AttachmentType === 'เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครเด็ก 7-18 ปี (ถ้าเกี่ยวข้อง)'
                    ) && (<>
                            {record.AttachmentType === 'เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครเด็ก 7-18 ปี (ถ้าเกี่ยวข้อง)'&&
                                <><p style={{ margin: 0,color:'gray' }}>กรุณาใช้ฟอร์ม <a target="_blank" rel="noopener noreferrer"
                                 href="https://docs.google.com/document/d/1AEY_efCz4hlSHYZiEanIE0F0_kLIqtvJ/edit?usp=drive_link&ouid=108248642863164545698&rtpof=true&sd=true">
                                    มว.จ.003-1 เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครเด็กอายุ 7-18 ปี</a> ในการยื่น </p></>}
                            {record.AttachmentType === 'เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครทั่วไป (ถ้าเกี่ยวข้อง)'&&
                                <><p style={{ margin: 0,color:'gray' }}>กรุณาใช้ฟอร์ม <a target="_blank" rel="noopener noreferrer" 
                                href="https://docs.google.com/document/d/1CdqP07e4QP_cL_QPbxDx0lQDO9pwHAxG/edit?usp=drive_link&ouid=108248642863164545698&rtpof=true&sd=true">
                                    มว.จ.003 เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัย</a> ในการยื่น </p></>}
                            <p style={{ margin: 0,color:'gray' }}>( อัพได้เพียงไฟล์สกุล PDF เท่านั้น / จำกัด 1 ไฟล์ )</p>
                        </>
                    )}
                    {record.AttachmentType === 'เอกสารสัญญาการให้ทุนวิจัย (ถ้ามี)' && (
                        <p style={{ margin: 0,color:'gray' }}>( อัพได้เพียงไฟล์สกุล PDF,JPG,PNG เท่านั้น / ไม่จำกัดจำนวนไฟล์ )</p>
                    )}
                    {record.AttachmentType === 'หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์' && (
                        <>
                            <p style={{ margin: 0,color:'red' }}>( **ต้องอัพโหลด** อัพได้เพียงไฟล์สกุล PDF,JPGJPG,PNG เท่านั้น / จำกัด 1 ไฟล์ )</p>
                            <p style={{ margin: 0,color:'red' }}>( ในกรณีที่มีผู้ร่วมวิจัยมากกว่า 1 ท่าน ให้ท่านรวมไฟล์ทั้งหมดเป็นไฟล์เดียว )</p>
                        </>)}
                    {(record.AttachmentType === 'เอกสารแสดงความยินยอมสำหรับอาสาสมัครกลุ่มเปราะบาง (ถ้าเกี่ยวข้อง)'
                    ||record.AttachmentType === 'เอกสารรับรองการสอบผ่านโครงร่างวิทยานิพนธ์ ภาคนิพนธ์ หรือการศึกษาค้นคว้าอิสระ'
                    ) && (<>
                            {record.AttachmentType === 'เอกสารแสดงความยินยอมสำหรับอาสาสมัครกลุ่มเปราะบาง (ถ้าเกี่ยวข้อง)'&&
                                <><p style={{ margin: 0,color:'gray' }}>กรุณาใช้ฟอร์ม <a target="_blank" rel="noopener noreferrer" 
                                href="https://docs.google.com/document/d/13KzYKP-mxXYsvmzbc0Q4V_-I1RtpRTA3/edit?usp=drive_link&ouid=108248642863164545698&rtpof=true&sd=true">
                                    มว.จ.003-2 เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครกลุ่มเปราะบาง</a> ในการยื่น </p></>}
                            <p style={{ margin: 0,color:'gray' }}>( อัพได้เพียงไฟล์สกุล PDF เท่านั้น / จำกัด 1 ไฟล์ )</p>
                        </>
                    )}
              </div>
            },{
                title:'สถานะเอกสาร',
                dataIndex:'Status'
            }
        ]} 
        pagination={false}
        dataSource={FileAttachment}/>

    <Modal
        open={ShowFile}
        onCancel={()=>{
            setShowFile(false);
            setPreviewUrl(null);
        }}
        footer={<></>}
        >
            <h2>ข้อมูลเอกสาร</h2>
            <hr/>
            {<>{previewUrl ? (
                <iframe
                    src={`https://i.vu.ac.th/vu_hrec_api/getEachFile/136`}
                    width="100%"
                    height="600px"
                    title="PDF Viewer"
                />
                ) : (
                <p>Loading...</p>
                )}</>}
                        
    </Modal>
    <Modal
        open={ShowMultipleFiles}
        onCancel={()=>{
            setShowMultipleFiles(false);
            setPreviewUrl(null);}}
        width={'50vw'}
        footer={<></>}
        >
        <h2>ข้อมูลเอกสาร</h2>
        <hr/>
        <List 
            pagination={{
                position: 'bottom',      
                align: 'end',            
                pageSize: 5,             
                showSizeChanger: true,   
                showQuickJumper: true    
              }}
              dataSource={SubFileList}
              renderItem={(item, index) =>(
                <><List.Item
                    actions={[<a onClick={()=>ViewTool(item.FileID)}>ดูไฟล์</a>, <a onClick={()=>DeleteTool(item.FileID)}>ลบ</a>]}>
                    <List.Item.Meta
                        title={<p>{item.FileName}</p>}
                       />
                </List.Item>
                    <br/>
                  
                </>
              )}
            />
            <br/>
            <Flex justify='center'>
              {
                previewUrl&&<>
                    {
                        FileType=='application/pdf'&&
                        <iframe
                            src={previewUrl}
                            width="80%"
                            height="600px"
                            title="PDF Viewer"
                            /> ||
                        <img src={previewUrl} alt="Uploaded Image" />
                    }
                </>
              }
            </Flex>
    </Modal>
    <Modal
    open={ShowImage}
    onCancel={()=>{
        setShowImage(false);
        setPreviewUrl(null);
    }}
    footer={<></>}
    >
         <h2>ข้อมูลเอกสาร</h2>
         <hr/>
        {previewUrl&&<Flex justify='center'>
            <img src={previewUrl} alt="Uploaded Image" />
        </Flex>}
        <br/>
        <Flex justify='center'>
            <Button type="primary" icon={<UploadOutlined />} onClick={() => {
                window.open(previewUrl||'', '_blank');
                }}>
                ดาวน์โหลด
            </Button>&nbsp;</Flex>
    </Modal>
    {AllData?.project_status=='แก้ไขข้อมูลตามผลพิจารณา'&&<Card>
        <h2>สรุปผลการพิจารณาของกรรมการ</h2>
        <>
        <h3><u>เกณฑ์ที่โครงการวิจัยเกี่ยวข้อง</u></h3>
            {(AllData.review_type=='การพิจารณาแบบยกเว้น (Exemption)'&&
                    AllData?.passed_measure
                )
                &&<>
                        <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1. เป็นกิจกรรมการเรียนการสอน การประกันคุณภาพการศึกษา การประกันคุณภาพ โรงพยาบาล การปรับปรุงคุณภาพงาน การประเมินผลการให้บริการของหน่วยงาน ทั้งนี้ต้องเป็นการดำเนินการตามแนวทางที่กำหนด") 
                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>} 1. เป็นกิจกรรมการเรียนการสอน การประกันคุณภาพการศึกษา การประกันคุณภาพ โรงพยาบาล การปรับปรุงคุณภาพงาน การประเมินผลการให้บริการของหน่วยงาน ทั้งนี้ต้องเป็นการดำเนินการตามแนวทางที่กำหนด</p>
                        <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("2. เป็นการวิจัยโดยใช้วิธีการสำรวจ สัมภาษณ์ ในประชากรที่เป็นผู้ใหญ่สุขภาพดี ทั้งนี้ต้อง") 
                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2. เป็นการวิจัยโดยใช้วิธีการสำรวจ สัมภาษณ์ ในประชากรที่เป็นผู้ใหญ่สุขภาพดี ทั้งนี้ต้อง</p>
                        <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("2.1 ไม่มีหัวข้อ คำถามที่อ่อนไหว เช่น พฤติกรรมทางเพศ พฤติกรรมผิดกฎหมาย พฤติกรรมที่เสื่อมเสียชื่อเสียงต่อบุคคล/ชุมชน") 
                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2.1 ไม่มีหัวข้อ คำถามที่อ่อนไหว เช่น พฤติกรรมทางเพศ พฤติกรรมผิดกฎหมาย พฤติกรรมที่เสื่อมเสียชื่อเสียงต่อบุคคล/ชุมชน</p>
                        <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("2.2 ไม่ถามทัศนคติที่หากเปิดเผยจะเป็นผลเสียแก่การจ้างงาน เช่น การสำรวจความพึง พอใจของข้าราชการเกี่ยวกับสวัสดิการที่ได้รับ") 
                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2.2 ไม่ถามทัศนคติที่หากเปิดเผยจะเป็นผลเสียแก่การจ้างงาน เช่น การสำรวจความพึง พอใจของข้าราชการเกี่ยวกับสวัสดิการที่ได้รับ</p>
                        <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("2.3 ผลการสำรวจไม่ทำให้องค์กรที่ให้ข้อมูลเสื่อมเสียชื่อเสียง") 
                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2.3 ผลการสำรวจไม่ทำให้องค์กรที่ให้ข้อมูลเสื่อมเสียชื่อเสียง</p>
                        <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("3. เป็นการวิจัยโดยการสังเกตพฤติกรรมของประชาชนในที่สาธารณะโดยที่") 
                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3. เป็นการวิจัยโดยการสังเกตพฤติกรรมของประชาชนในที่สาธารณะโดยที่</p>
                        <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("3.1 ผู้วิจัยไม่ไปแทรกแซงหรือจัดฉาก") 
                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3.1 ผู้วิจัยไม่ไปแทรกแซงหรือจัดฉาก </p>
                        <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("}3.2 พฤติกรรมที่ถูกสังเกต/สถานที่ที่ใช้สังเกตไม่ล่วงล้ำความเป็นส่วนตัว") 
                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3.2 พฤติกรรมที่ถูกสังเกต/สถานที่ที่ใช้สังเกตไม่ล่วงล้ำความเป็นส่วนตัว</p>
                        <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("3.3 ไม่บันทึกข้อมูลในลักษณะที่บ่งบอกถึงตัวบุคคลได้") 
                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3.3 ไม่บันทึกข้อมูลในลักษณะที่บ่งบอกถึงตัวบุคคลได้</p>
                        <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("4. เป็นรายงานผู้ป่วย (Case Report) ที่ผู้เสนอขอยกเว้นได้แสดงการปกป้องความลับของผู้ป่วยอย่าง เหมาะสม (หมายเหตุ ผู้วิจัยพึงตระหนักว่าวารสารวิชาการหลายแห่งอาจกำหนดให้มีหลักฐานหนังสือความยินยอมขอใช้ข้อมูลผู้ป่วย หรือภาพผู้ป่วย แล้วแต่กรณี)") 
                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}4. เป็นรายงานผู้ป่วย (Case Report) ที่ผู้เสนอขอยกเว้นได้แสดงการปกป้องความลับของผู้ป่วยอย่าง เหมาะสม (หมายเหตุ ผู้วิจัยพึงตระหนักว่าวารสารวิชาการหลายแห่งอาจกำหนดให้มีหลักฐานหนังสือความยินยอมขอใช้ข้อมูลผู้ป่วย หรือภาพผู้ป่วย แล้วแต่กรณี)  </p>
                        <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("5. เป็นการวิจัยโดยทดสอบรสชาติอาหาร คุณภาพของอาหาร และความพึงพอใจของผู้บริโภคใน ภาพรวม โดยอาหารที่นำมาทดสอบต้องปลอดภัย และได้มาตรฐานตามข้อกำหนดของสำนักงานคณะกรรมการ อาหารและยา (อย.) ทั้งนี้ ขึ้นอยู่กับดุลยพินิจของประธานฯ หรือผู้ที่ได้รับมอบหมาย") 
                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}5. เป็นการวิจัยโดยทดสอบรสชาติอาหาร คุณภาพของอาหาร และความพึงพอใจของผู้บริโภคใน ภาพรวม โดยอาหารที่นำมาทดสอบต้องปลอดภัย และได้มาตรฐานตามข้อกำหนดของสำนักงานคณะกรรมการ อาหารและยา (อย.) ทั้งนี้ ขึ้นอยู่กับดุลยพินิจของประธานฯ หรือผู้ที่ได้รับมอบหมาย  </p>
                </>}
                {(AllData.review_type=='การพิจารณาแบบเร่งรัด (Expedited Review)'&&
                AllData?.passed_measure)&&<>
                    <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1. ส่วนแก้ไขเพิ่มเติมโครงการวิจัยที่เป็นการแก้ไขเพิ่มเติมเล็กน้อยของโครงการวิจัยที่อนุมัติไปแล้วที่เป็นผลให้ความเสี่ยงของผู้ร่วมการวิจัยเพิ่มไม่เกินความเสี่ยงต่ำหรือไม่ทำให้การประเมินความเสี่ยงต่อผลประโยชน์เปลี่ยนไปอย่างมีนัยสำคัญ (Non-significant Risk) เช่น การแก้ไขคำผิด การแก้ไขรูปแบบการเขียนที่ ยังคงความหมายเดิม หรือการเปลี่ยนผู้วิจัยหรือที่อยู่ที่ติดต่อ </p>
                    <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2. โครงการวิจัยที่มีการสัมภาษณ์ ใช้แบบสอบถามและไม่เป็นข้อมูลลับ หรือข้อมูลที่อ่อนไหว และไม่ก่อผลเสียหายต่อสถานภาพ หรือสิทธิประโยชน์ของบุคคล และไม่ก้าวล่วงความอ่อนไหวของประชากรที่เกี่ยวข้อง</p>
                    <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3. การเก็บรวบรวมข้อมูล โดยมีวัตถุประสงค์เพื่อการวิจัยโดยกระบวนการที่ไม่รุกล้ำความเป็นส่วนตัวของบุคคลหรือกลุ่มบุคคล</p>
                    <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}4. การวิจัยเกี่ยวกับการใช้ข้อมูล (Data) บันทึก (Records) เอกสาร (Documents) ที่เก็บรวบรวมไว้แล้วโดยไม่เชื่อมโยงไปถึงตัวบุคคล</p>
                    <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}5. การวิจัยเกี่ยวกับพฤติกรรมที่เกี่ยวข้องกับลักษณะบุคคล กลุ่มบุคคล หรือการวิจัยที่ใช้วิธีการ สำรวจ สัมภาษณ์ ซักประวัติ การสนทนากลุ่ม (Focus Group) การประเมินโปรแกรมหรือวิธีการเกี่ยวกับการ ประกันคุณภาพ (Quality Assurance)  </p>
                </>}
                {(AllData.review_type=='การพิจารณาแบบเต็มชุด (Full Board Review)'&&
                AllData?.passed_measure)&&<>
                    <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.การวิจัยที่เกี่ยวข้องกับประชากรกลุ่มเปราะบาง (Vulnerable Group) ได้แก่") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.การวิจัยที่เกี่ยวข้องกับประชากรกลุ่มเปราะบาง (Vulnerable Group) ได้แก่</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.2 การวิจัยในผู้ป่วยที่ไม่สามารถรักษาหายได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.2 การวิจัยในผู้ป่วยที่ไม่สามารถรักษาหายได้</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.3 การวิจัยในผู้ป่วยด้วยโรคที่สังคมไม่ยอมรับ เช่น โรคเอดส์ เป็นต้น") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.3 การวิจัยในผู้ป่วยด้วยโรคที่สังคมไม่ยอมรับ เช่น โรคเอดส์ เป็นต้น</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.4 การวิจัยในผู้ที่มีความบกพร่องในการตัดสินใจ เช่น ผู้ที่มีความบกพร่องทางจิต ความทรงจำ หรือความผิดปกติด้านพฤติกรรม") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.4 การวิจัยในผู้ที่มีความบกพร่องในการตัดสินใจ เช่น ผู้ที่มีความบกพร่องทางจิต ความทรงจำ หรือความผิดปกติด้านพฤติกรรม</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.5 การวิจัยในเด็กที่อยู่ในสถานพินิจ/สถานสงเคราะห์") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.5 การวิจัยในเด็กที่อยู่ในสถานพินิจ/สถานสงเคราะห์</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.6 การวิจัยในกลุ่มผู้สูงอายุที่อยู่ในสถานสงเคราะห์</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.7 การวิจัยในทารกในครรภ์/หญิงตั้งครรภ์</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.8 การวิจัยในกลุ่มผู้ลี้ภัย</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.9 การวิจัยในนักโทษหรือผู้ต้องขัง</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.10 การวิจัยในกลุ่มคนไร้ที่อยู่</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.11 การวิจัยในชนกลุ่มน้อย หรือผู้ที่ไม่สามารถสื่อสารด้วยภาษาไทยได้</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.12 การวิจัยในกลุ่มผู้ขายบริการทางเพศ</p>
                    <p style={{marginLeft:'10vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.13 การวิจัยในผู้เสพหรือผู้ขายสารเสพติด</p>
                    <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2. การเปิดเผยตัวของผู้ร่วมการวิจัยก่อให้เกิดความเสี่ยงต่อการรับโทษทางแพ่ง หรือทางอาญา หรือเป็นผลเสียต่อสถานะทางการเงิน การจ้างงาน การประกัน หรืออาชีพ หรือถูกตีตรา เว้นแต่ โครงการวิจัยได้แสดงมาตรการปกป้องการรุกล้ำความเป็นส่วนตัว และความลับไม่ให้รั่วไหลอย่างเหมาะสมจนความเสี่ยงเหลือไม่เกินความเสี่ยงต่ำ</p>
                    <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3. โครงการวิจัยที่ได้รับการพิจารณาให้การรับรองแล้ว และผู้วิจัยต้องการยื่นส่วนแก้ไขเปลี่ยนแปลง (Amendment) ซึ่งส่วนแก้ไขเพิ่มเติมนั้นมีผลกระทบเปลี่ยนแปลงความเสี่ยงของผู้ร่วมการวิจัยที่เพิ่มขึ้นมากกว่าเกณฑ์การประเมินโครงการวิจัยแบบเร่งรัด ต้องนำเข้าพิจารณาแบบเต็มชุด </p>
                    <p style={{marginLeft:'5vw'}}>{JSON.parse(AllData?.passed_measure||'[]').includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                    && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>} 4. โครงการวิจัยที่ได้รับการรับรองแล้วและผู้วิจัยต้องการรายงานความก้าวหน้าของโครงการ (Progress Report) แต่มีการดำเนินการที่เบี่ยงเบนไม่ปฏิบัติตามหรือฝ่าฝืนโครงการวิจัยต้องนำเข้า พิจารณาแบบเต็มชุด</p>
                </>}</>
                <Form form={form}>
                {AllData?.consideration_issues&&<> 
                <h3><u>ประเด็นพิจารณา</u></h3>
                    <Table columns={[
                        {
                            title:'ประเด็นพิจารณา',
                            dataIndex:'topic',
                            width:'15vw'
                        },{
                            title: 'ข้อเสนอแนะ',
                            dataIndex: 'consideration_issues',
                            render: (text: string) => (
                              <p
                                style={{ fontSize: '16px', marginLeft: 20 }}
                                dangerouslySetInnerHTML={{
                                  __html: (text || '').replace(/\r\n|\n|\r/g, '<br/>'),
                                }}
                              />
                            ),
                          }
                          ,{
                            title: 'ข้อโต้แย้งของนักวัจิย',
                            dataIndex: 'consideration_issues',
                            width:'20vw',
                            render: (_: any, record: Issue, index: number) => (
                                <Form.Item
                                  name={['researcher_issues_arguement', index]} // <-- unique per row
                                  style={{ marginBottom: 0 }}
                                >
                                  <TextArea
                                    placeholder="กรอกข้อความสำหรับโต้แย้งหรือรับทราบคำสั่งแก้ไข"
                                    autoSize
                                  />
                                </Form.Item>
                              ),
                          }
                    ]} 
                    pagination={false} 
                    dataSource={JSON.parse(AllData.consideration_issues) as Issue[]}/></>}
                    {AllData?.suggestion&&<>
                    <br/>
                    <p><span style={{fontWeight:'bold'}}>ข้อเสนอแนะเพิ่มเติม</span> : {AllData?.suggestion}</p>
                    </>}
                
                <Form.Item name='researcher_arguement' label='บันทึกข้อความจากผู้ยื่นคำขอ'>
                    <TextArea autoSize/>
                </Form.Item>
                </Form>
        <Card>
            <p>ขอความอนุเคราะห์โปรดทำไฮทไลท์ในไฟล์ที่ท่านแก้ไขด้วย</p>
        </Card>
    </Card>}
    {AllData?.project_status=='ได้รับหนังสือรับรองจากอธิการบดี'&&<>
                <Card>
                    <h2>หนังสือรับรองจากหนังสือรับรองจากอธิการบดี</h2>
                    {moment(AllData.ApprovalAdded).isSameOrAfter(moment(), 'day')&&
                        <>
                            <Flex justify='center'>
                                <iframe  style={{width:'50vw',height:'100vh'}} src={ApprovalFileData||undefined}/>
                            </Flex>
                            <p style={{marginLeft:'5vw'}}>นักวิจัยสามารถดาวน์โหลดเอกสารดังกล่าวได้ตั้งแต่ {moment(AllData.ApprovalAdded).format("DD MMMM YYYY")} 
                            {" "}ถึง{" "}
                            {moment(AllData.ApprovalAdded).add(3, "years").format("DD MMMM YYYY")}</p>
                            <Flex justify="center" style={{ marginTop: "1rem" }}>
                            <a
                                href={ApprovalFileData || undefined}
                                download={`หนังสือรับรอง_${AllData.Order_ID || "approval"}.pdf`}
                            >
                                <Button type="primary" icon={<DownloadOutlined />}>
                                ดาวน์โหลดไฟล์
                                </Button>
                            </a>
                            </Flex>
                        </>
                    ||<>
                        <Flex justify='center'>
                            <p style={{color:'red'}}>เอกสารดังกล่าวหมดเวลาในการดาวน์โหลดและนำไปใช้แล้ว</p>
                        </Flex>
                    </>}
                </Card>
            </>}
            <br/>
    <Flex justify="center"><Button onClick={()=>setSubmit(true)} 
    disabled={(Percentage !== 100
    ||(AllData?.project_status!='แก้ไข'&&
       AllData?.project_status!='แก้ไขข้อมูลตามผลพิจารณา'
    ))} >ยื่นเอกสาร</Button></Flex>
    
    <Modal
        open={submit}
        onCancel={()=>setSubmit(false)}
        footer={<></>}
        >
        <h1>ยืนยันการส่ง</h1>
        <p>หากทำการยิ่นข้อมูลเข้าระบบแล้วจะไม่สามารถแก้ไขข้อมูลหรือลบข้อมูลได้อีก คุณยืนยันที่จะยื่นข้อมูลจริงหรือไม่</p>
        <Flex justify='flex-end'>
            <Button type='primary' onClick={()=>setSubmit(false)} danger>ยกเลิก</Button>
            &nbsp;<Button type='primary' onClick={()=>SubmitData()}>ยืนยัน</Button></Flex>
    </Modal></LoadingOverlay>
    </>)
}